import client from "../apolloClient";
import type {
  ApolloQueryResult,
  ObservableQuery,
  WatchQueryOptions,
  MutationOptions,
} from "@apollo/client";
import { readable } from "svelte/store";
import type { Readable } from "svelte/store";
import gql from "graphql-tag";
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Time: { input: any; output: any };
  Timestamp: { input: any; output: any };
  URL: { input: any; output: any };
};

export enum Alignment {
  Bottom = "BOTTOM",
  Center = "CENTER",
  Top = "TOP",
}

export type ArticleBlock = {
  __typename?: "ArticleBlock";
  alignment: Alignment;
  cta?: Maybe<Link>;
  image: FliteImage;
  invert: Scalars["Boolean"]["output"];
  position: Position;
  reverse: Scalars["Boolean"]["output"];
  subtitle?: Maybe<Scalars["String"]["output"]>;
  text?: Maybe<Markdown>;
  textPosition: Position;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type Banner = {
  __typename?: "Banner";
  bgColour?: Maybe<Scalars["String"]["output"]>;
  createDate: Scalars["Timestamp"]["output"];
  icon?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  link1?: Maybe<Link>;
  link2?: Maybe<Link>;
  publishFrom: Scalars["Timestamp"]["output"];
  text?: Maybe<Markdown>;
  textLight?: Maybe<Scalars["Boolean"]["output"]>;
  updateDate: Scalars["Timestamp"]["output"];
};

export type BannerConnection = {
  __typename?: "BannerConnection";
  edges: Array<Maybe<BannerEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type BannerEdge = {
  __typename?: "BannerEdge";
  node?: Maybe<Banner>;
};

export type Block =
  | ArticleBlock
  | Carousel
  | DestinationFeature
  | DynamicGrid
  | FilmBlock
  | PromoBlock
  | QaBlock
  | RecommendationBlock
  | ShopTheLook
  | SingleFeatureBlock
  | TextWithCtaBlock
  | TwoImageHeroBlock;

export type BreadcrumbConnection = {
  __typename?: "BreadcrumbConnection";
  edges: Array<NavItemEdge>;
  totalCount: Scalars["Int"]["output"];
};

export type CampaignPromoBlock = {
  __typename?: "CampaignPromoBlock";
  content?: Maybe<ContentBlock>;
  template: Scalars["String"]["output"];
};

export type Card = {
  __typename?: "Card";
  content?: Maybe<CardContent>;
  type?: Maybe<CardType>;
};

export type CardConnection = {
  __typename?: "CardConnection";
  edges: Array<Maybe<CardEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type CardContent = DynamicGridCard | EditorialCard | ProductCard;

export type CardEdge = {
  __typename?: "CardEdge";
  cursor?: Maybe<Scalars["ID"]["output"]>;
  node?: Maybe<Card>;
};

export enum CardType {
  DynamicGrid = "DYNAMIC_GRID",
  Editorial = "EDITORIAL",
  Product = "PRODUCT",
}

export type Carousel = {
  __typename?: "Carousel";
  cards?: Maybe<CardConnection>;
  collection?: Maybe<Collection>;
  cta?: Maybe<Link>;
  size: CarouselSize;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type CarouselCardsArgs = {
  after?: InputMaybe<Scalars["ID"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum CarouselSize {
  Four = "FOUR",
  Six = "SIX",
  Three = "THREE",
}

export type Collection = {
  __typename?: "Collection";
  descriptionHtml?: Maybe<Scalars["String"]["output"]>;
  filters?: Maybe<FilterGroup>;
  handle: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  image?: Maybe<Image>;
  matchAnyTags: Scalars["Boolean"]["output"];
  promoBlocks?: Maybe<Array<Maybe<CampaignPromoBlock>>>;
  seo: Seo;
  slotImages?: Maybe<Array<Scalars["String"]["output"]>>;
  sortOrder?: Maybe<CollectionSortOrder>;
  subNavLinks?: Maybe<Array<Maybe<NavItem>>>;
  tags: Array<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  totalProducts?: Maybe<Scalars["Int"]["output"]>;
  updatedAt: Scalars["Time"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
};

export type CollectionFiltersArgs = {
  appliedFilters?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  forType: FilterType;
};

export type CollectionImageArgs = {
  crop?: InputMaybe<CropRegion>;
  maxHeight?: InputMaybe<Scalars["Int"]["input"]>;
  maxWidth?: InputMaybe<Scalars["Int"]["input"]>;
  scale?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CollectionPromoBlocksArgs = {
  campaignId?: InputMaybe<Scalars["ID"]["input"]>;
  template: Scalars["String"]["input"];
};

export type CollectionTotalProductsArgs = {
  appliedFilters?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export enum CollectionSortOrder {
  /** Alphabetically, in ascending order (A - Z). */
  AlphaAsc = "ALPHA_ASC",
  /** Alphabetically, in descending order (Z - A). */
  AlphaDesc = "ALPHA_DESC",
  /** By best-selling products. */
  BestSelling = "BEST_SELLING",
  /** By date created, in ascending order (oldest - newest). */
  Created = "CREATED",
  /** By date created, in descending order (newest - oldest). */
  CreatedDesc = "CREATED_DESC",
  /** In the order set manually by the merchant. */
  Manual = "MANUAL",
  /** By price, in ascending order (lowest - highest). */
  PriceAsc = "PRICE_ASC",
  /** By price, in descending order (highest - lowest). */
  PriceDesc = "PRICE_DESC",
}

export type ContentBlock = {
  __typename?: "ContentBlock";
  block?: Maybe<Block>;
  contentType?: Maybe<ContentType>;
  createDate?: Maybe<Scalars["Timestamp"]["output"]>;
  id: Scalars["ID"]["output"];
  order?: Maybe<Scalars["Int"]["output"]>;
  updateDate?: Maybe<Scalars["Timestamp"]["output"]>;
};

export enum ContentType {
  ArticleBlock = "ARTICLE_BLOCK",
  DestinationFeatureBlock = "DESTINATION_FEATURE_BLOCK",
  DynamicGridBlock = "DYNAMIC_GRID_BLOCK",
  FilmBlock = "FILM_BLOCK",
  ProductCarousel = "PRODUCT_CAROUSEL",
  PromoPrimary = "PROMO_PRIMARY",
  PromoSecondary = "PROMO_SECONDARY",
  QaBlock = "QA_BLOCK",
  RecommendationBlock = "RECOMMENDATION_BLOCK",
  ShopTheLookBlock = "SHOP_THE_LOOK_BLOCK",
  SingleFeatureBlock = "SINGLE_FEATURE_BLOCK",
  TextWithCtaBlock = "TEXT_WITH_CTA_BLOCK",
  TwoImageHeroBlock = "TWO_IMAGE_HERO_BLOCK",
}

export enum CropRegion {
  /** Keep the bottom of the image. */
  Bottom = "BOTTOM",
  /** Keep the center of the image. */
  Center = "CENTER",
  /** Keep the left of the image. */
  Left = "LEFT",
  /** Keep the right of the image. */
  Right = "RIGHT",
  /** Keep the top of the image. */
  Top = "TOP",
}

export type Customer = {
  __typename?: "Customer";
  acceptsMarketing: Scalars["Boolean"]["output"];
  gender: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  locale: Scalars["String"]["output"];
};

export type CustomerUpdateMarketingInput = {
  acceptsMarketing: Scalars["Boolean"]["input"];
  gender: Scalars["String"]["input"];
  locale: Scalars["String"]["input"];
};

export type DestinationFeature = {
  __typename?: "DestinationFeature";
  blockCta?: Maybe<Link>;
  /** The default limit is 4, if the limit is not in the range of 1-4 only 4 cards will be returned */
  cards?: Maybe<CardConnection>;
  collection?: Maybe<Collection>;
  cta?: Maybe<Link>;
  cta2?: Maybe<Link>;
  fontTheme?: Maybe<FontTheme>;
  image: FliteImage;
  imageSm: FliteImage;
  invert: Scalars["Boolean"]["output"];
  mediaType?: Maybe<MediaType>;
  rectangleDivider: Scalars["Boolean"]["output"];
  subtitle?: Maybe<Scalars["String"]["output"]>;
  text?: Maybe<Markdown>;
  title?: Maybe<Scalars["String"]["output"]>;
  video: FliteVideo;
  videoSm: FliteVideo;
};

export type DestinationFeatureCardsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DynamicGrid = {
  __typename?: "DynamicGrid";
  autoscroll: Scalars["Boolean"]["output"];
  cards?: Maybe<CardConnection>;
  speed: Speed;
};

export type DynamicGridCardsArgs = {
  after?: InputMaybe<Scalars["ID"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DynamicGridCard = {
  __typename?: "DynamicGridCard";
  content?: Maybe<DynamicGridCardContent>;
};

export type DynamicGridCardContent = {
  __typename?: "DynamicGridCardContent";
  alignment: Alignment;
  body?: Maybe<Markdown>;
  cta?: Maybe<Link>;
  image: FliteImage;
  invert: Scalars["Boolean"]["output"];
  position: Position;
  textAlignment?: Maybe<Position>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type EditorialCard = {
  __typename?: "EditorialCard";
  cta?: Maybe<Link>;
  image?: Maybe<FliteImage>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type FilmBlock = {
  __typename?: "FilmBlock";
  coverImage: FliteImage;
  coverImageSm: FliteImage;
  title?: Maybe<Scalars["String"]["output"]>;
  video: FliteVideo;
  videoSm: FliteVideo;
};

export type FilterGroup = {
  __typename?: "FilterGroup";
  label: Scalars["String"]["output"];
  type: FilterType;
  values: Array<FilterValue>;
};

export enum FilterType {
  Category = "CATEGORY",
  Color = "COLOR",
  Material = "MATERIAL",
  Size = "SIZE",
}

export type FilterValue = {
  __typename?: "FilterValue";
  count: Scalars["Int"]["output"];
  rawTag: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type FliteImage = {
  __typename?: "FliteImage";
  altText?: Maybe<Scalars["String"]["output"]>;
  uri?: Maybe<Scalars["String"]["output"]>;
};

export type FliteVideo = {
  __typename?: "FliteVideo";
  altText?: Maybe<Scalars["String"]["output"]>;
  uri?: Maybe<Scalars["String"]["output"]>;
};

export enum FontTheme {
  Primary = "PRIMARY",
  Secondary = "SECONDARY",
}

export type Image = {
  __typename?: "Image";
  altText?: Maybe<Scalars["String"]["output"]>;
  height?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  originalSrc: Scalars["URL"]["output"];
  width?: Maybe<Scalars["Int"]["output"]>;
};

export type ImageOriginalSrcArgs = {
  crop?: InputMaybe<CropRegion>;
  maxHeight?: InputMaybe<Scalars["Int"]["input"]>;
  maxWidth?: InputMaybe<Scalars["Int"]["input"]>;
  scale?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ImageConnection = {
  __typename?: "ImageConnection";
  edges?: Maybe<Array<Maybe<ImageEdge>>>;
};

export type ImageEdge = {
  __typename?: "ImageEdge";
  node?: Maybe<Image>;
};

export type Link = {
  __typename?: "Link";
  bgColour?: Maybe<Scalars["String"]["output"]>;
  href: Scalars["String"]["output"];
  text: Scalars["String"]["output"];
  textLight?: Maybe<Scalars["Boolean"]["output"]>;
};

export type Markdown = {
  __typename?: "Markdown";
  html: Scalars["String"]["output"];
  md: Scalars["String"]["output"];
};

export enum MediaType {
  Image = "IMAGE",
  Video = "VIDEO",
}

export type Meta = {
  __typename?: "Meta";
  description?: Maybe<Scalars["String"]["output"]>;
  keywords?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  /** Create unregistered customer for marketing */
  AddMarketingEmail?: Maybe<Scalars["Boolean"]["output"]>;
  /** Update customers marketing preferences */
  CustomerUpdateMarketing?: Maybe<Customer>;
};

export type MutationAddMarketingEmailArgs = {
  email: Scalars["String"]["input"];
  gender: Scalars["String"]["input"];
  honeypot?: InputMaybe<Scalars["String"]["input"]>;
  locale: Scalars["String"]["input"];
};

export type MutationCustomerUpdateMarketingArgs = {
  customerAccessToken: Scalars["String"]["input"];
  input?: InputMaybe<CustomerUpdateMarketingInput>;
};

export type Nav = {
  __typename?: "Nav";
  handle: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  items?: Maybe<Array<Maybe<NavItem>>>;
  store: Scalars["String"]["output"];
};

export type NavItem = {
  __typename?: "NavItem";
  /** Nav item parents for breadcrumb structure */
  breadcrumbs?: Maybe<BreadcrumbConnection>;
  /** Full path built up from parent nav structure, relative to the site base URL */
  fullPath?: Maybe<Scalars["String"]["output"]>;
  /** Determines whether the item should be hidden from the nav */
  hidden?: Maybe<Scalars["Boolean"]["output"]>;
  /** Determines whether the item should be highlighted */
  highlighted?: Maybe<Scalars["Boolean"]["output"]>;
  /** Specific href part for this nav item */
  href?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** Child nav items */
  items?: Maybe<Array<Maybe<NavItem>>>;
  /** Nav item promo image */
  promoimage?: Maybe<PromoImage>;
  /** The resource this item represents */
  resource?: Maybe<Resource>;
  /** Custom nav template identifier */
  template?: Maybe<Scalars["String"]["output"]>;
  /** Nav item title */
  title?: Maybe<Scalars["String"]["output"]>;
};

export type NavItemEdge = {
  __typename?: "NavItemEdge";
  node: NavItem;
};

export type Page = {
  __typename?: "Page";
  contents?: Maybe<Array<Maybe<ContentBlock>>>;
  id: Scalars["ID"]["output"];
  meta?: Maybe<Meta>;
  theme?: Maybe<PageTheme>;
};

export type PageInfo = {
  __typename?: "PageInfo";
  endCursor: Scalars["ID"]["output"];
  hasNextPage: Scalars["Boolean"]["output"];
};

export enum PageTheme {
  Dark = "DARK",
  Light = "LIGHT",
  Primary = "PRIMARY",
  Secondary = "SECONDARY",
}

export enum Position {
  Center = "CENTER",
  Left = "LEFT",
  Right = "RIGHT",
}

export type Price = {
  __typename?: "Price";
  amount?: Maybe<Scalars["String"]["output"]>;
  currencyCode?: Maybe<Scalars["String"]["output"]>;
};

export type PriceRange = {
  __typename?: "PriceRange";
  maxVariantPrice?: Maybe<Price>;
  minVariantPrice?: Maybe<Price>;
};

export type Product = {
  __typename?: "Product";
  badge?: Maybe<Scalars["String"]["output"]>;
  canonicalUrl?: Maybe<Scalars["String"]["output"]>;
  compareAtPriceRange?: Maybe<PriceRange>;
  handle?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  image?: Maybe<Image>;
  options?: Maybe<Array<Maybe<ProductOptions>>>;
  priceRange?: Maybe<PriceRange>;
  showPrice: Scalars["Boolean"]["output"];
  subtitle?: Maybe<Scalars["String"]["output"]>;
  tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  title?: Maybe<Scalars["String"]["output"]>;
  totalInventory?: Maybe<Scalars["Int"]["output"]>;
  variants?: Maybe<VariantConnection>;
};

export type ProductCard = {
  __typename?: "ProductCard";
  product?: Maybe<Product>;
};

export type ProductOption = {
  __typename?: "ProductOption";
  name?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export type ProductOptions = {
  __typename?: "ProductOptions";
  name?: Maybe<Scalars["String"]["output"]>;
  values?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type ProductVariant = {
  __typename?: "ProductVariant";
  compareAtPrice?: Maybe<Price>;
  id?: Maybe<Scalars["ID"]["output"]>;
  price?: Maybe<Price>;
  quantityAvailable?: Maybe<Scalars["Int"]["output"]>;
  selectedOptions?: Maybe<Array<Maybe<ProductOption>>>;
};

export type PromoBlock = {
  __typename?: "PromoBlock";
  imageLg?: Maybe<FliteImage>;
  imageSm?: Maybe<FliteImage>;
  link1?: Maybe<Link>;
  link2?: Maybe<Link>;
  subtitle?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type PromoImage = {
  __typename?: "PromoImage";
  image?: Maybe<FliteImage>;
  link?: Maybe<Link>;
};

export type QaBlock = {
  __typename?: "QABlock";
  alignment: Alignment;
  answer1?: Maybe<Markdown>;
  answer2?: Maybe<Markdown>;
  answer3?: Maybe<Markdown>;
  answer4?: Maybe<Markdown>;
  cta?: Maybe<Link>;
  image: FliteImage;
  invert: Scalars["Boolean"]["output"];
  position: Position;
  question1?: Maybe<Scalars["String"]["output"]>;
  question2?: Maybe<Scalars["String"]["output"]>;
  question3?: Maybe<Scalars["String"]["output"]>;
  question4?: Maybe<Scalars["String"]["output"]>;
  reverse: Scalars["Boolean"]["output"];
  textPosition: Position;
};

export type Query = {
  __typename?: "Query";
  /** Check the validity of a preview token, the token should be supplied in the Authorization header */
  CheckPreviewToken?: Maybe<TokenCheck>;
  /** Retrieve a single collection using the numerical ID e.g. 261305499828 */
  Collection?: Maybe<Collection>;
  /** Retrieve a customers marketing preferences */
  CustomerGetMarketing?: Maybe<Customer>;
  /** Retrieve list of banners */
  ListBanners?: Maybe<BannerConnection>;
  /** Retrive specific navigation structure for a store */
  Nav?: Maybe<Nav>;
  /** Lookup nav item by URL */
  NavItemByURL?: Maybe<NavItem>;
  /** Retrieve a page, to preview a revision an Authorization token must be provided */
  Page?: Maybe<Page>;
  /** Lookup resource by URL */
  ResourceByURL?: Maybe<Resource>;
};

export type QueryCollectionArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryCustomerGetMarketingArgs = {
  customerAccessToken: Scalars["String"]["input"];
};

export type QueryListBannersArgs = {
  after?: InputMaybe<Scalars["ID"]["input"]>;
  first: Scalars["Int"]["input"];
};

export type QueryNavArgs = {
  id: Scalars["ID"]["input"];
  revisionId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryNavItemByUrlArgs = {
  navRevisionId?: InputMaybe<Scalars["ID"]["input"]>;
  url: Scalars["String"]["input"];
};

export type QueryPageArgs = {
  id: Scalars["ID"]["input"];
  revisionId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryResourceByUrlArgs = {
  navRevisionId?: InputMaybe<Scalars["ID"]["input"]>;
  url: Scalars["String"]["input"];
};

export type RecommendationBlock = {
  __typename?: "RecommendationBlock";
  cta?: Maybe<Link>;
  placementId?: Maybe<Scalars["String"]["output"]>;
  position: Position;
  size: CarouselSize;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type Resource = Collection | Page;

export type Seo = {
  __typename?: "SEO";
  description?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ShopTheLook = {
  __typename?: "ShopTheLook";
  blockCta?: Maybe<Link>;
  /** The default limit is 4, if the limit is not in the range of 1-4 only 4 cards will be returned */
  cards?: Maybe<CardConnection>;
  collection?: Maybe<Collection>;
  cta?: Maybe<Link>;
  cta2?: Maybe<Link>;
  fontTheme?: Maybe<FontTheme>;
  image: FliteImage;
  imageSm: FliteImage;
  invert: Scalars["Boolean"]["output"];
  mediaType?: Maybe<MediaType>;
  rectangleDivider: Scalars["Boolean"]["output"];
  text?: Maybe<Markdown>;
  title?: Maybe<Scalars["String"]["output"]>;
  video: FliteVideo;
  videoSm: FliteVideo;
};

export type ShopTheLookCardsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SingleFeatureBlock = {
  __typename?: "SingleFeatureBlock";
  alignment: Alignment;
  animate: Scalars["Boolean"]["output"];
  blockCta?: Maybe<Link>;
  cta?: Maybe<Link>;
  cta2?: Maybe<Link>;
  fontTheme?: Maybe<FontTheme>;
  image: FliteImage;
  imageSm: FliteImage;
  invert: Scalars["Boolean"]["output"];
  mediaType?: Maybe<MediaType>;
  position: Position;
  rectangleDivider: Scalars["Boolean"]["output"];
  subtitle?: Maybe<Scalars["String"]["output"]>;
  text?: Maybe<Markdown>;
  title?: Maybe<Scalars["String"]["output"]>;
  video: FliteVideo;
  videoSm: FliteVideo;
};

export enum Speed {
  Fast = "FAST",
  Medium = "MEDIUM",
  Slow = "SLOW",
}

export type TextWithCtaBlock = {
  __typename?: "TextWithCtaBlock";
  align: Position;
  fontTheme?: Maybe<FontTheme>;
  link1?: Maybe<Link>;
  link2?: Maybe<Link>;
  rectangleDivider: Scalars["Boolean"]["output"];
  text?: Maybe<Markdown>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type TokenCheck = {
  __typename?: "TokenCheck";
  valid: Scalars["Boolean"]["output"];
};

export type TwoImageHeroBlock = {
  __typename?: "TwoImageHeroBlock";
  animate: Scalars["Boolean"]["output"];
  cta?: Maybe<Link>;
  cta2?: Maybe<Link>;
  image: FliteImage;
  image2: FliteImage;
  invert: Scalars["Boolean"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  title2?: Maybe<Scalars["String"]["output"]>;
};

export type VariantConnection = {
  __typename?: "VariantConnection";
  edges?: Maybe<Array<Maybe<VariantEdge>>>;
};

export type VariantEdge = {
  __typename?: "VariantEdge";
  node?: Maybe<ProductVariant>;
};

export type CardsFragmentFragment = {
  __typename?: "CardConnection";
  totalCount: number;
  edges: Array<
    | {
        __typename?: "CardEdge";
        node?:
          | {
              __typename?: "Card";
              type?: CardType | null | undefined;
              content?:
                | { __typename?: "DynamicGridCard" }
                | {
                    __typename?: "EditorialCard";
                    title?: string | null | undefined;
                    image?:
                      | {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        }
                      | null
                      | undefined;
                    cta?:
                      | { __typename?: "Link"; href: string; text: string }
                      | null
                      | undefined;
                  }
                | {
                    __typename?: "ProductCard";
                    product?:
                      | {
                          __typename?: "Product";
                          id?: string | null | undefined;
                          title?: string | null | undefined;
                          subtitle?: string | null | undefined;
                          badge?: string | null | undefined;
                          handle?: string | null | undefined;
                          canonicalUrl?: string | null | undefined;
                          showPrice: boolean;
                          tags?:
                            | Array<string | null | undefined>
                            | null
                            | undefined;
                          image?:
                            | {
                                __typename?: "Image";
                                id?: string | null | undefined;
                                altText?: string | null | undefined;
                                originalSrc: any;
                              }
                            | null
                            | undefined;
                          priceRange?:
                            | {
                                __typename?: "PriceRange";
                                maxVariantPrice?:
                                  | {
                                      __typename?: "Price";
                                      amount?: string | null | undefined;
                                      currencyCode?: string | null | undefined;
                                    }
                                  | null
                                  | undefined;
                                minVariantPrice?:
                                  | {
                                      __typename?: "Price";
                                      amount?: string | null | undefined;
                                      currencyCode?: string | null | undefined;
                                    }
                                  | null
                                  | undefined;
                              }
                            | null
                            | undefined;
                          compareAtPriceRange?:
                            | {
                                __typename?: "PriceRange";
                                maxVariantPrice?:
                                  | {
                                      __typename?: "Price";
                                      amount?: string | null | undefined;
                                      currencyCode?: string | null | undefined;
                                    }
                                  | null
                                  | undefined;
                                minVariantPrice?:
                                  | {
                                      __typename?: "Price";
                                      amount?: string | null | undefined;
                                      currencyCode?: string | null | undefined;
                                    }
                                  | null
                                  | undefined;
                              }
                            | null
                            | undefined;
                          options?:
                            | Array<
                                | {
                                    __typename?: "ProductOptions";
                                    name?: string | null | undefined;
                                    values?:
                                      | Array<string | null | undefined>
                                      | null
                                      | undefined;
                                  }
                                | null
                                | undefined
                              >
                            | null
                            | undefined;
                          variants?:
                            | {
                                __typename?: "VariantConnection";
                                edges?:
                                  | Array<
                                      | {
                                          __typename?: "VariantEdge";
                                          node?:
                                            | {
                                                __typename?: "ProductVariant";
                                                id?: string | null | undefined;
                                                quantityAvailable?:
                                                  | number
                                                  | null
                                                  | undefined;
                                                selectedOptions?:
                                                  | Array<
                                                      | {
                                                          __typename?: "ProductOption";
                                                          name?:
                                                            | string
                                                            | null
                                                            | undefined;
                                                          value?:
                                                            | string
                                                            | null
                                                            | undefined;
                                                        }
                                                      | null
                                                      | undefined
                                                    >
                                                  | null
                                                  | undefined;
                                                price?:
                                                  | {
                                                      __typename?: "Price";
                                                      amount?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      currencyCode?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                                compareAtPrice?:
                                                  | {
                                                      __typename?: "Price";
                                                      amount?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      currencyCode?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined
                                    >
                                  | null
                                  | undefined;
                              }
                            | null
                            | undefined;
                        }
                      | null
                      | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined
  >;
};

export type CarouselFragmentFragment = {
  __typename?: "Carousel";
  title?: string | null | undefined;
  size: CarouselSize;
  cta?: { __typename?: "Link"; href: string; text: string } | null | undefined;
  collection?:
    | { __typename?: "Collection"; url?: string | null | undefined }
    | null
    | undefined;
  cards?:
    | {
        __typename?: "CardConnection";
        totalCount: number;
        edges: Array<
          | {
              __typename?: "CardEdge";
              node?:
                | {
                    __typename?: "Card";
                    type?: CardType | null | undefined;
                    content?:
                      | { __typename?: "DynamicGridCard" }
                      | {
                          __typename?: "EditorialCard";
                          title?: string | null | undefined;
                          image?:
                            | {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              }
                            | null
                            | undefined;
                          cta?:
                            | {
                                __typename?: "Link";
                                href: string;
                                text: string;
                              }
                            | null
                            | undefined;
                        }
                      | {
                          __typename?: "ProductCard";
                          product?:
                            | {
                                __typename?: "Product";
                                id?: string | null | undefined;
                                title?: string | null | undefined;
                                subtitle?: string | null | undefined;
                                badge?: string | null | undefined;
                                handle?: string | null | undefined;
                                canonicalUrl?: string | null | undefined;
                                showPrice: boolean;
                                tags?:
                                  | Array<string | null | undefined>
                                  | null
                                  | undefined;
                                image?:
                                  | {
                                      __typename?: "Image";
                                      id?: string | null | undefined;
                                      altText?: string | null | undefined;
                                      originalSrc: any;
                                    }
                                  | null
                                  | undefined;
                                priceRange?:
                                  | {
                                      __typename?: "PriceRange";
                                      maxVariantPrice?:
                                        | {
                                            __typename?: "Price";
                                            amount?: string | null | undefined;
                                            currencyCode?:
                                              | string
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                      minVariantPrice?:
                                        | {
                                            __typename?: "Price";
                                            amount?: string | null | undefined;
                                            currencyCode?:
                                              | string
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                    }
                                  | null
                                  | undefined;
                                compareAtPriceRange?:
                                  | {
                                      __typename?: "PriceRange";
                                      maxVariantPrice?:
                                        | {
                                            __typename?: "Price";
                                            amount?: string | null | undefined;
                                            currencyCode?:
                                              | string
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                      minVariantPrice?:
                                        | {
                                            __typename?: "Price";
                                            amount?: string | null | undefined;
                                            currencyCode?:
                                              | string
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                    }
                                  | null
                                  | undefined;
                                options?:
                                  | Array<
                                      | {
                                          __typename?: "ProductOptions";
                                          name?: string | null | undefined;
                                          values?:
                                            | Array<string | null | undefined>
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined
                                    >
                                  | null
                                  | undefined;
                                variants?:
                                  | {
                                      __typename?: "VariantConnection";
                                      edges?:
                                        | Array<
                                            | {
                                                __typename?: "VariantEdge";
                                                node?:
                                                  | {
                                                      __typename?: "ProductVariant";
                                                      id?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      quantityAvailable?:
                                                        | number
                                                        | null
                                                        | undefined;
                                                      selectedOptions?:
                                                        | Array<
                                                            | {
                                                                __typename?: "ProductOption";
                                                                name?:
                                                                  | string
                                                                  | null
                                                                  | undefined;
                                                                value?:
                                                                  | string
                                                                  | null
                                                                  | undefined;
                                                              }
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      price?:
                                                        | {
                                                            __typename?: "Price";
                                                            amount?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            currencyCode?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      compareAtPrice?:
                                                        | {
                                                            __typename?: "Price";
                                                            amount?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            currencyCode?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined
                                          >
                                        | null
                                        | undefined;
                                    }
                                  | null
                                  | undefined;
                              }
                            | null
                            | undefined;
                        }
                      | null
                      | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined
        >;
      }
    | null
    | undefined;
};

export type TextWithCtaFragmentFragment = {
  __typename?: "TextWithCtaBlock";
  title?: string | null | undefined;
  align: Position;
  rectangleDivider: boolean;
  text?:
    | { __typename?: "Markdown"; md: string; html: string }
    | null
    | undefined;
  link1?:
    | {
        __typename?: "Link";
        href: string;
        text: string;
        bgColour?: string | null | undefined;
        textLight?: boolean | null | undefined;
      }
    | null
    | undefined;
  link2?:
    | {
        __typename?: "Link";
        href: string;
        text: string;
        bgColour?: string | null | undefined;
        textLight?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type TwoImageHeroFragmentFragment = {
  __typename?: "TwoImageHeroBlock";
  title?: string | null | undefined;
  title2?: string | null | undefined;
  invert: boolean;
  animate: boolean;
  cta?:
    | {
        __typename?: "Link";
        href: string;
        text: string;
        bgColour?: string | null | undefined;
      }
    | null
    | undefined;
  image: {
    __typename?: "FliteImage";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  cta2?:
    | {
        __typename?: "Link";
        href: string;
        text: string;
        bgColour?: string | null | undefined;
      }
    | null
    | undefined;
  image2: {
    __typename?: "FliteImage";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
};

export type FilmFragmentFragment = {
  __typename?: "FilmBlock";
  title?: string | null | undefined;
  video: {
    __typename?: "FliteVideo";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  videoSm: {
    __typename?: "FliteVideo";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  coverImage: {
    __typename?: "FliteImage";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  coverImageSm: {
    __typename?: "FliteImage";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
};

export type SingleFeatureFragmentFragment = {
  __typename?: "SingleFeatureBlock";
  mediaType?: MediaType | null | undefined;
  title?: string | null | undefined;
  subtitle?: string | null | undefined;
  position: Position;
  alignment: Alignment;
  invert: boolean;
  animate: boolean;
  rectangleDivider: boolean;
  image: {
    __typename?: "FliteImage";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  imageSm: {
    __typename?: "FliteImage";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  video: {
    __typename?: "FliteVideo";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  videoSm: {
    __typename?: "FliteVideo";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  text?:
    | { __typename?: "Markdown"; md: string; html: string }
    | null
    | undefined;
  cta?:
    | {
        __typename?: "Link";
        href: string;
        text: string;
        bgColour?: string | null | undefined;
        textLight?: boolean | null | undefined;
      }
    | null
    | undefined;
  cta2?:
    | {
        __typename?: "Link";
        href: string;
        text: string;
        bgColour?: string | null | undefined;
        textLight?: boolean | null | undefined;
      }
    | null
    | undefined;
  blockCta?:
    | {
        __typename?: "Link";
        href: string;
        text: string;
        bgColour?: string | null | undefined;
        textLight?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type ShopTheLookFragmentFragment = {
  __typename?: "ShopTheLook";
  mediaType?: MediaType | null | undefined;
  title?: string | null | undefined;
  invert: boolean;
  rectangleDivider: boolean;
  image: {
    __typename?: "FliteImage";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  imageSm: {
    __typename?: "FliteImage";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  text?:
    | { __typename?: "Markdown"; md: string; html: string }
    | null
    | undefined;
  cta?:
    | {
        __typename?: "Link";
        href: string;
        text: string;
        bgColour?: string | null | undefined;
        textLight?: boolean | null | undefined;
      }
    | null
    | undefined;
  cta2?:
    | {
        __typename?: "Link";
        href: string;
        text: string;
        bgColour?: string | null | undefined;
        textLight?: boolean | null | undefined;
      }
    | null
    | undefined;
  blockCta?:
    | {
        __typename?: "Link";
        href: string;
        text: string;
        bgColour?: string | null | undefined;
        textLight?: boolean | null | undefined;
      }
    | null
    | undefined;
  video: {
    __typename?: "FliteVideo";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  videoSm: {
    __typename?: "FliteVideo";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  collection?:
    | { __typename?: "Collection"; url?: string | null | undefined }
    | null
    | undefined;
  cards?:
    | {
        __typename?: "CardConnection";
        totalCount: number;
        edges: Array<
          | {
              __typename?: "CardEdge";
              node?:
                | {
                    __typename?: "Card";
                    type?: CardType | null | undefined;
                    content?:
                      | { __typename?: "DynamicGridCard" }
                      | {
                          __typename?: "EditorialCard";
                          title?: string | null | undefined;
                          image?:
                            | {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              }
                            | null
                            | undefined;
                          cta?:
                            | {
                                __typename?: "Link";
                                href: string;
                                text: string;
                              }
                            | null
                            | undefined;
                        }
                      | {
                          __typename?: "ProductCard";
                          product?:
                            | {
                                __typename?: "Product";
                                id?: string | null | undefined;
                                title?: string | null | undefined;
                                subtitle?: string | null | undefined;
                                badge?: string | null | undefined;
                                handle?: string | null | undefined;
                                canonicalUrl?: string | null | undefined;
                                showPrice: boolean;
                                tags?:
                                  | Array<string | null | undefined>
                                  | null
                                  | undefined;
                                image?:
                                  | {
                                      __typename?: "Image";
                                      id?: string | null | undefined;
                                      altText?: string | null | undefined;
                                      originalSrc: any;
                                    }
                                  | null
                                  | undefined;
                                priceRange?:
                                  | {
                                      __typename?: "PriceRange";
                                      maxVariantPrice?:
                                        | {
                                            __typename?: "Price";
                                            amount?: string | null | undefined;
                                            currencyCode?:
                                              | string
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                      minVariantPrice?:
                                        | {
                                            __typename?: "Price";
                                            amount?: string | null | undefined;
                                            currencyCode?:
                                              | string
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                    }
                                  | null
                                  | undefined;
                                compareAtPriceRange?:
                                  | {
                                      __typename?: "PriceRange";
                                      maxVariantPrice?:
                                        | {
                                            __typename?: "Price";
                                            amount?: string | null | undefined;
                                            currencyCode?:
                                              | string
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                      minVariantPrice?:
                                        | {
                                            __typename?: "Price";
                                            amount?: string | null | undefined;
                                            currencyCode?:
                                              | string
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                    }
                                  | null
                                  | undefined;
                                options?:
                                  | Array<
                                      | {
                                          __typename?: "ProductOptions";
                                          name?: string | null | undefined;
                                          values?:
                                            | Array<string | null | undefined>
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined
                                    >
                                  | null
                                  | undefined;
                                variants?:
                                  | {
                                      __typename?: "VariantConnection";
                                      edges?:
                                        | Array<
                                            | {
                                                __typename?: "VariantEdge";
                                                node?:
                                                  | {
                                                      __typename?: "ProductVariant";
                                                      id?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      quantityAvailable?:
                                                        | number
                                                        | null
                                                        | undefined;
                                                      selectedOptions?:
                                                        | Array<
                                                            | {
                                                                __typename?: "ProductOption";
                                                                name?:
                                                                  | string
                                                                  | null
                                                                  | undefined;
                                                                value?:
                                                                  | string
                                                                  | null
                                                                  | undefined;
                                                              }
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      price?:
                                                        | {
                                                            __typename?: "Price";
                                                            amount?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            currencyCode?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      compareAtPrice?:
                                                        | {
                                                            __typename?: "Price";
                                                            amount?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            currencyCode?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined
                                          >
                                        | null
                                        | undefined;
                                    }
                                  | null
                                  | undefined;
                              }
                            | null
                            | undefined;
                        }
                      | null
                      | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined
        >;
      }
    | null
    | undefined;
};

export type RecommendationFragmentFragment = {
  __typename?: "RecommendationBlock";
  title?: string | null | undefined;
  placementId?: string | null | undefined;
  size: CarouselSize;
  position: Position;
  cta?:
    | {
        __typename?: "Link";
        href: string;
        text: string;
        bgColour?: string | null | undefined;
        textLight?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type ArticleFragmentFragment = {
  __typename?: "ArticleBlock";
  title?: string | null | undefined;
  subtitle?: string | null | undefined;
  invert: boolean;
  position: Position;
  alignment: Alignment;
  reverse: boolean;
  textPosition: Position;
  text?:
    | { __typename?: "Markdown"; md: string; html: string }
    | null
    | undefined;
  image: {
    __typename?: "FliteImage";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  cta?:
    | {
        __typename?: "Link";
        href: string;
        text: string;
        bgColour?: string | null | undefined;
        textLight?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type QaFragmentFragment = {
  __typename?: "QABlock";
  question1?: string | null | undefined;
  question2?: string | null | undefined;
  question3?: string | null | undefined;
  question4?: string | null | undefined;
  invert: boolean;
  position: Position;
  alignment: Alignment;
  reverse: boolean;
  textPosition: Position;
  answer1?:
    | { __typename?: "Markdown"; md: string; html: string }
    | null
    | undefined;
  answer2?:
    | { __typename?: "Markdown"; md: string; html: string }
    | null
    | undefined;
  answer3?:
    | { __typename?: "Markdown"; md: string; html: string }
    | null
    | undefined;
  answer4?:
    | { __typename?: "Markdown"; md: string; html: string }
    | null
    | undefined;
  image: {
    __typename?: "FliteImage";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  cta?:
    | {
        __typename?: "Link";
        href: string;
        text: string;
        bgColour?: string | null | undefined;
        textLight?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type DynamicGridFragmentFragment = {
  __typename?: "DynamicGrid";
  autoscroll: boolean;
  speed: Speed;
  cards?:
    | {
        __typename?: "CardConnection";
        totalCount: number;
        edges: Array<
          | {
              __typename?: "CardEdge";
              node?:
                | {
                    __typename?: "Card";
                    content?:
                      | {
                          __typename?: "DynamicGridCard";
                          content?:
                            | {
                                __typename?: "DynamicGridCardContent";
                                title?: string | null | undefined;
                                position: Position;
                                alignment: Alignment;
                                textAlignment?: Position | null | undefined;
                                invert: boolean;
                                image: {
                                  __typename?: "FliteImage";
                                  uri?: string | null | undefined;
                                  altText?: string | null | undefined;
                                };
                                body?:
                                  | {
                                      __typename?: "Markdown";
                                      md: string;
                                      html: string;
                                    }
                                  | null
                                  | undefined;
                                cta?:
                                  | {
                                      __typename?: "Link";
                                      href: string;
                                      text: string;
                                    }
                                  | null
                                  | undefined;
                              }
                            | null
                            | undefined;
                        }
                      | { __typename?: "EditorialCard" }
                      | { __typename?: "ProductCard" }
                      | null
                      | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined
        >;
      }
    | null
    | undefined;
};

export type DestinationFeatureFragmentFragment = {
  __typename?: "DestinationFeature";
  mediaType?: MediaType | null | undefined;
  title?: string | null | undefined;
  subtitle?: string | null | undefined;
  invert: boolean;
  rectangleDivider: boolean;
  image: {
    __typename?: "FliteImage";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  imageSm: {
    __typename?: "FliteImage";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  video: {
    __typename?: "FliteVideo";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  videoSm: {
    __typename?: "FliteVideo";
    uri?: string | null | undefined;
    altText?: string | null | undefined;
  };
  collection?:
    | { __typename?: "Collection"; url?: string | null | undefined }
    | null
    | undefined;
  text?:
    | { __typename?: "Markdown"; md: string; html: string }
    | null
    | undefined;
  cta?:
    | {
        __typename?: "Link";
        href: string;
        text: string;
        bgColour?: string | null | undefined;
        textLight?: boolean | null | undefined;
      }
    | null
    | undefined;
  cta2?:
    | {
        __typename?: "Link";
        href: string;
        text: string;
        bgColour?: string | null | undefined;
        textLight?: boolean | null | undefined;
      }
    | null
    | undefined;
  blockCta?:
    | {
        __typename?: "Link";
        href: string;
        text: string;
        bgColour?: string | null | undefined;
        textLight?: boolean | null | undefined;
      }
    | null
    | undefined;
  cards?:
    | {
        __typename?: "CardConnection";
        totalCount: number;
        edges: Array<
          | {
              __typename?: "CardEdge";
              node?:
                | {
                    __typename?: "Card";
                    type?: CardType | null | undefined;
                    content?:
                      | { __typename?: "DynamicGridCard" }
                      | {
                          __typename?: "EditorialCard";
                          title?: string | null | undefined;
                          image?:
                            | {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              }
                            | null
                            | undefined;
                          cta?:
                            | {
                                __typename?: "Link";
                                href: string;
                                text: string;
                              }
                            | null
                            | undefined;
                        }
                      | {
                          __typename?: "ProductCard";
                          product?:
                            | {
                                __typename?: "Product";
                                id?: string | null | undefined;
                                title?: string | null | undefined;
                                subtitle?: string | null | undefined;
                                badge?: string | null | undefined;
                                handle?: string | null | undefined;
                                canonicalUrl?: string | null | undefined;
                                showPrice: boolean;
                                tags?:
                                  | Array<string | null | undefined>
                                  | null
                                  | undefined;
                                image?:
                                  | {
                                      __typename?: "Image";
                                      id?: string | null | undefined;
                                      altText?: string | null | undefined;
                                      originalSrc: any;
                                    }
                                  | null
                                  | undefined;
                                priceRange?:
                                  | {
                                      __typename?: "PriceRange";
                                      maxVariantPrice?:
                                        | {
                                            __typename?: "Price";
                                            amount?: string | null | undefined;
                                            currencyCode?:
                                              | string
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                      minVariantPrice?:
                                        | {
                                            __typename?: "Price";
                                            amount?: string | null | undefined;
                                            currencyCode?:
                                              | string
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                    }
                                  | null
                                  | undefined;
                                compareAtPriceRange?:
                                  | {
                                      __typename?: "PriceRange";
                                      maxVariantPrice?:
                                        | {
                                            __typename?: "Price";
                                            amount?: string | null | undefined;
                                            currencyCode?:
                                              | string
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                      minVariantPrice?:
                                        | {
                                            __typename?: "Price";
                                            amount?: string | null | undefined;
                                            currencyCode?:
                                              | string
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                    }
                                  | null
                                  | undefined;
                                options?:
                                  | Array<
                                      | {
                                          __typename?: "ProductOptions";
                                          name?: string | null | undefined;
                                          values?:
                                            | Array<string | null | undefined>
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined
                                    >
                                  | null
                                  | undefined;
                                variants?:
                                  | {
                                      __typename?: "VariantConnection";
                                      edges?:
                                        | Array<
                                            | {
                                                __typename?: "VariantEdge";
                                                node?:
                                                  | {
                                                      __typename?: "ProductVariant";
                                                      id?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      quantityAvailable?:
                                                        | number
                                                        | null
                                                        | undefined;
                                                      selectedOptions?:
                                                        | Array<
                                                            | {
                                                                __typename?: "ProductOption";
                                                                name?:
                                                                  | string
                                                                  | null
                                                                  | undefined;
                                                                value?:
                                                                  | string
                                                                  | null
                                                                  | undefined;
                                                              }
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      price?:
                                                        | {
                                                            __typename?: "Price";
                                                            amount?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            currencyCode?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      compareAtPrice?:
                                                        | {
                                                            __typename?: "Price";
                                                            amount?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            currencyCode?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined
                                          >
                                        | null
                                        | undefined;
                                    }
                                  | null
                                  | undefined;
                              }
                            | null
                            | undefined;
                        }
                      | null
                      | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined
        >;
      }
    | null
    | undefined;
};

export type FiltersFragmentFragment = {
  __typename?: "Collection";
  totalProducts?: number | null | undefined;
  filterColors?:
    | {
        __typename?: "FilterGroup";
        type: FilterType;
        label: string;
        values: Array<{
          __typename?: "FilterValue";
          value: string;
          rawTag: string;
          count: number;
        }>;
      }
    | null
    | undefined;
  filterSizes?:
    | {
        __typename?: "FilterGroup";
        type: FilterType;
        label: string;
        values: Array<{
          __typename?: "FilterValue";
          value: string;
          rawTag: string;
          count: number;
        }>;
      }
    | null
    | undefined;
  filterMaterials?:
    | {
        __typename?: "FilterGroup";
        type: FilterType;
        label: string;
        values: Array<{
          __typename?: "FilterValue";
          value: string;
          rawTag: string;
          count: number;
        }>;
      }
    | null
    | undefined;
  filterCategory?:
    | {
        __typename?: "FilterGroup";
        type: FilterType;
        label: string;
        values: Array<{
          __typename?: "FilterValue";
          value: string;
          rawTag: string;
          count: number;
        }>;
      }
    | null
    | undefined;
};

export type GetCmsCollectionQueryVariables = Exact<{
  colId: Scalars["ID"]["input"];
  appliedFilters?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;

export type GetCmsCollectionQuery = {
  __typename?: "Query";
  Collection?:
    | {
        __typename?: "Collection";
        id: string;
        totalProducts?: number | null | undefined;
        filterColors?:
          | {
              __typename?: "FilterGroup";
              type: FilterType;
              label: string;
              values: Array<{
                __typename?: "FilterValue";
                value: string;
                rawTag: string;
                count: number;
              }>;
            }
          | null
          | undefined;
        filterSizes?:
          | {
              __typename?: "FilterGroup";
              type: FilterType;
              label: string;
              values: Array<{
                __typename?: "FilterValue";
                value: string;
                rawTag: string;
                count: number;
              }>;
            }
          | null
          | undefined;
        filterMaterials?:
          | {
              __typename?: "FilterGroup";
              type: FilterType;
              label: string;
              values: Array<{
                __typename?: "FilterValue";
                value: string;
                rawTag: string;
                count: number;
              }>;
            }
          | null
          | undefined;
        filterCategory?:
          | {
              __typename?: "FilterGroup";
              type: FilterType;
              label: string;
              values: Array<{
                __typename?: "FilterValue";
                value: string;
                rawTag: string;
                count: number;
              }>;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateFiltersQueryVariables = Exact<{
  colId: Scalars["ID"]["input"];
  appliedFilters?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;

export type UpdateFiltersQuery = {
  __typename?: "Query";
  Collection?:
    | {
        __typename?: "Collection";
        id: string;
        totalProducts?: number | null | undefined;
        filterColors?:
          | {
              __typename?: "FilterGroup";
              type: FilterType;
              label: string;
              values: Array<{
                __typename?: "FilterValue";
                value: string;
                rawTag: string;
                count: number;
              }>;
            }
          | null
          | undefined;
        filterSizes?:
          | {
              __typename?: "FilterGroup";
              type: FilterType;
              label: string;
              values: Array<{
                __typename?: "FilterValue";
                value: string;
                rawTag: string;
                count: number;
              }>;
            }
          | null
          | undefined;
        filterMaterials?:
          | {
              __typename?: "FilterGroup";
              type: FilterType;
              label: string;
              values: Array<{
                __typename?: "FilterValue";
                value: string;
                rawTag: string;
                count: number;
              }>;
            }
          | null
          | undefined;
        filterCategory?:
          | {
              __typename?: "FilterGroup";
              type: FilterType;
              label: string;
              values: Array<{
                __typename?: "FilterValue";
                value: string;
                rawTag: string;
                count: number;
              }>;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type MarketingSignupMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  gender: Scalars["String"]["input"];
  locale: Scalars["String"]["input"];
  honeypot?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type MarketingSignupMutation = {
  __typename?: "Mutation";
  AddMarketingEmail?: boolean | null | undefined;
};

export type GetCustomerMarketingQueryVariables = Exact<{
  token: Scalars["String"]["input"];
}>;

export type GetCustomerMarketingQuery = {
  __typename?: "Query";
  CustomerGetMarketing?:
    | {
        __typename?: "Customer";
        id: string;
        acceptsMarketing: boolean;
        locale: string;
        gender: string;
      }
    | null
    | undefined;
};

export type SetMarketingMutationVariables = Exact<{
  token: Scalars["String"]["input"];
  input: CustomerUpdateMarketingInput;
}>;

export type SetMarketingMutation = {
  __typename?: "Mutation";
  CustomerUpdateMarketing?:
    | {
        __typename?: "Customer";
        id: string;
        acceptsMarketing: boolean;
        locale: string;
        gender: string;
      }
    | null
    | undefined;
};

export type BannersQueryVariables = Exact<{ [key: string]: never }>;

export type BannersQuery = {
  __typename?: "Query";
  ListBanners?:
    | {
        __typename?: "BannerConnection";
        edges: Array<
          | {
              __typename?: "BannerEdge";
              node?:
                | {
                    __typename?: "Banner";
                    id: string;
                    icon?: string | null | undefined;
                    createDate: any;
                    updateDate: any;
                    publishFrom: any;
                    bgColour?: string | null | undefined;
                    textLight?: boolean | null | undefined;
                    text?:
                      | { __typename?: "Markdown"; html: string; md: string }
                      | null
                      | undefined;
                    link1?:
                      | { __typename?: "Link"; text: string; href: string }
                      | null
                      | undefined;
                    link2?:
                      | { __typename?: "Link"; text: string; href: string }
                      | null
                      | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined
        >;
      }
    | null
    | undefined;
};

export type GetPageQueryVariables = Exact<{
  pageId: Scalars["ID"]["input"];
  revisionId?: InputMaybe<Scalars["ID"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetPageQuery = {
  __typename?: "Query";
  Page?:
    | {
        __typename?: "Page";
        id: string;
        theme?: PageTheme | null | undefined;
        meta?:
          | {
              __typename?: "Meta";
              title?: string | null | undefined;
              description?: string | null | undefined;
              keywords?: Array<string | null | undefined> | null | undefined;
            }
          | null
          | undefined;
        contents?:
          | Array<
              | {
                  __typename?: "ContentBlock";
                  id: string;
                  createDate?: any | null | undefined;
                  updateDate?: any | null | undefined;
                  contentType?: ContentType | null | undefined;
                  order?: number | null | undefined;
                  block?:
                    | {
                        __typename?: "ArticleBlock";
                        title?: string | null | undefined;
                        subtitle?: string | null | undefined;
                        invert: boolean;
                        position: Position;
                        alignment: Alignment;
                        reverse: boolean;
                        textPosition: Position;
                        text?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "Carousel";
                        title?: string | null | undefined;
                        size: CarouselSize;
                        cta?:
                          | { __typename?: "Link"; href: string; text: string }
                          | null
                          | undefined;
                        collection?:
                          | {
                              __typename?: "Collection";
                              url?: string | null | undefined;
                            }
                          | null
                          | undefined;
                        cards?:
                          | {
                              __typename?: "CardConnection";
                              totalCount: number;
                              edges: Array<
                                | {
                                    __typename?: "CardEdge";
                                    node?:
                                      | {
                                          __typename?: "Card";
                                          type?: CardType | null | undefined;
                                          content?:
                                            | { __typename?: "DynamicGridCard" }
                                            | {
                                                __typename?: "EditorialCard";
                                                title?:
                                                  | string
                                                  | null
                                                  | undefined;
                                                image?:
                                                  | {
                                                      __typename?: "FliteImage";
                                                      uri?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      altText?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                                cta?:
                                                  | {
                                                      __typename?: "Link";
                                                      href: string;
                                                      text: string;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | {
                                                __typename?: "ProductCard";
                                                product?:
                                                  | {
                                                      __typename?: "Product";
                                                      id?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      subtitle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      badge?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      handle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      canonicalUrl?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      showPrice: boolean;
                                                      tags?:
                                                        | Array<
                                                            | string
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      image?:
                                                        | {
                                                            __typename?: "Image";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            altText?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            originalSrc: any;
                                                          }
                                                        | null
                                                        | undefined;
                                                      priceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      compareAtPriceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      options?:
                                                        | Array<
                                                            | {
                                                                __typename?: "ProductOptions";
                                                                name?:
                                                                  | string
                                                                  | null
                                                                  | undefined;
                                                                values?:
                                                                  | Array<
                                                                      | string
                                                                      | null
                                                                      | undefined
                                                                    >
                                                                  | null
                                                                  | undefined;
                                                              }
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      variants?:
                                                        | {
                                                            __typename?: "VariantConnection";
                                                            edges?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "VariantEdge";
                                                                      node?:
                                                                        | {
                                                                            __typename?: "ProductVariant";
                                                                            id?:
                                                                              | string
                                                                              | null
                                                                              | undefined;
                                                                            quantityAvailable?:
                                                                              | number
                                                                              | null
                                                                              | undefined;
                                                                            selectedOptions?:
                                                                              | Array<
                                                                                  | {
                                                                                      __typename?: "ProductOption";
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                      value?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                    }
                                                                                  | null
                                                                                  | undefined
                                                                                >
                                                                              | null
                                                                              | undefined;
                                                                            price?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                            compareAtPrice?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | null
                                | undefined
                              >;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "DestinationFeature";
                        mediaType?: MediaType | null | undefined;
                        title?: string | null | undefined;
                        subtitle?: string | null | undefined;
                        invert: boolean;
                        rectangleDivider: boolean;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        imageSm: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        video: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        videoSm: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        collection?:
                          | {
                              __typename?: "Collection";
                              url?: string | null | undefined;
                            }
                          | null
                          | undefined;
                        text?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        cta2?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        blockCta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        cards?:
                          | {
                              __typename?: "CardConnection";
                              totalCount: number;
                              edges: Array<
                                | {
                                    __typename?: "CardEdge";
                                    node?:
                                      | {
                                          __typename?: "Card";
                                          type?: CardType | null | undefined;
                                          content?:
                                            | { __typename?: "DynamicGridCard" }
                                            | {
                                                __typename?: "EditorialCard";
                                                title?:
                                                  | string
                                                  | null
                                                  | undefined;
                                                image?:
                                                  | {
                                                      __typename?: "FliteImage";
                                                      uri?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      altText?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                                cta?:
                                                  | {
                                                      __typename?: "Link";
                                                      href: string;
                                                      text: string;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | {
                                                __typename?: "ProductCard";
                                                product?:
                                                  | {
                                                      __typename?: "Product";
                                                      id?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      subtitle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      badge?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      handle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      canonicalUrl?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      showPrice: boolean;
                                                      tags?:
                                                        | Array<
                                                            | string
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      image?:
                                                        | {
                                                            __typename?: "Image";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            altText?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            originalSrc: any;
                                                          }
                                                        | null
                                                        | undefined;
                                                      priceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      compareAtPriceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      options?:
                                                        | Array<
                                                            | {
                                                                __typename?: "ProductOptions";
                                                                name?:
                                                                  | string
                                                                  | null
                                                                  | undefined;
                                                                values?:
                                                                  | Array<
                                                                      | string
                                                                      | null
                                                                      | undefined
                                                                    >
                                                                  | null
                                                                  | undefined;
                                                              }
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      variants?:
                                                        | {
                                                            __typename?: "VariantConnection";
                                                            edges?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "VariantEdge";
                                                                      node?:
                                                                        | {
                                                                            __typename?: "ProductVariant";
                                                                            id?:
                                                                              | string
                                                                              | null
                                                                              | undefined;
                                                                            quantityAvailable?:
                                                                              | number
                                                                              | null
                                                                              | undefined;
                                                                            selectedOptions?:
                                                                              | Array<
                                                                                  | {
                                                                                      __typename?: "ProductOption";
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                      value?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                    }
                                                                                  | null
                                                                                  | undefined
                                                                                >
                                                                              | null
                                                                              | undefined;
                                                                            price?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                            compareAtPrice?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | null
                                | undefined
                              >;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "DynamicGrid";
                        autoscroll: boolean;
                        speed: Speed;
                        cards?:
                          | {
                              __typename?: "CardConnection";
                              totalCount: number;
                              edges: Array<
                                | {
                                    __typename?: "CardEdge";
                                    node?:
                                      | {
                                          __typename?: "Card";
                                          content?:
                                            | {
                                                __typename?: "DynamicGridCard";
                                                content?:
                                                  | {
                                                      __typename?: "DynamicGridCardContent";
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      position: Position;
                                                      alignment: Alignment;
                                                      textAlignment?:
                                                        | Position
                                                        | null
                                                        | undefined;
                                                      invert: boolean;
                                                      image: {
                                                        __typename?: "FliteImage";
                                                        uri?:
                                                          | string
                                                          | null
                                                          | undefined;
                                                        altText?:
                                                          | string
                                                          | null
                                                          | undefined;
                                                      };
                                                      body?:
                                                        | {
                                                            __typename?: "Markdown";
                                                            md: string;
                                                            html: string;
                                                          }
                                                        | null
                                                        | undefined;
                                                      cta?:
                                                        | {
                                                            __typename?: "Link";
                                                            href: string;
                                                            text: string;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | { __typename?: "EditorialCard" }
                                            | { __typename?: "ProductCard" }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | null
                                | undefined
                              >;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "FilmBlock";
                        title?: string | null | undefined;
                        video: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        videoSm: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        coverImage: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        coverImageSm: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                      }
                    | { __typename?: "PromoBlock" }
                    | {
                        __typename?: "QABlock";
                        question1?: string | null | undefined;
                        question2?: string | null | undefined;
                        question3?: string | null | undefined;
                        question4?: string | null | undefined;
                        invert: boolean;
                        position: Position;
                        alignment: Alignment;
                        reverse: boolean;
                        textPosition: Position;
                        answer1?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        answer2?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        answer3?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        answer4?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "RecommendationBlock";
                        title?: string | null | undefined;
                        placementId?: string | null | undefined;
                        size: CarouselSize;
                        position: Position;
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "ShopTheLook";
                        mediaType?: MediaType | null | undefined;
                        title?: string | null | undefined;
                        invert: boolean;
                        rectangleDivider: boolean;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        imageSm: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        text?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        cta2?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        blockCta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        video: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        videoSm: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        collection?:
                          | {
                              __typename?: "Collection";
                              url?: string | null | undefined;
                            }
                          | null
                          | undefined;
                        cards?:
                          | {
                              __typename?: "CardConnection";
                              totalCount: number;
                              edges: Array<
                                | {
                                    __typename?: "CardEdge";
                                    node?:
                                      | {
                                          __typename?: "Card";
                                          type?: CardType | null | undefined;
                                          content?:
                                            | { __typename?: "DynamicGridCard" }
                                            | {
                                                __typename?: "EditorialCard";
                                                title?:
                                                  | string
                                                  | null
                                                  | undefined;
                                                image?:
                                                  | {
                                                      __typename?: "FliteImage";
                                                      uri?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      altText?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                                cta?:
                                                  | {
                                                      __typename?: "Link";
                                                      href: string;
                                                      text: string;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | {
                                                __typename?: "ProductCard";
                                                product?:
                                                  | {
                                                      __typename?: "Product";
                                                      id?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      subtitle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      badge?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      handle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      canonicalUrl?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      showPrice: boolean;
                                                      tags?:
                                                        | Array<
                                                            | string
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      image?:
                                                        | {
                                                            __typename?: "Image";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            altText?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            originalSrc: any;
                                                          }
                                                        | null
                                                        | undefined;
                                                      priceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      compareAtPriceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      options?:
                                                        | Array<
                                                            | {
                                                                __typename?: "ProductOptions";
                                                                name?:
                                                                  | string
                                                                  | null
                                                                  | undefined;
                                                                values?:
                                                                  | Array<
                                                                      | string
                                                                      | null
                                                                      | undefined
                                                                    >
                                                                  | null
                                                                  | undefined;
                                                              }
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      variants?:
                                                        | {
                                                            __typename?: "VariantConnection";
                                                            edges?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "VariantEdge";
                                                                      node?:
                                                                        | {
                                                                            __typename?: "ProductVariant";
                                                                            id?:
                                                                              | string
                                                                              | null
                                                                              | undefined;
                                                                            quantityAvailable?:
                                                                              | number
                                                                              | null
                                                                              | undefined;
                                                                            selectedOptions?:
                                                                              | Array<
                                                                                  | {
                                                                                      __typename?: "ProductOption";
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                      value?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                    }
                                                                                  | null
                                                                                  | undefined
                                                                                >
                                                                              | null
                                                                              | undefined;
                                                                            price?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                            compareAtPrice?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | null
                                | undefined
                              >;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "SingleFeatureBlock";
                        mediaType?: MediaType | null | undefined;
                        title?: string | null | undefined;
                        subtitle?: string | null | undefined;
                        position: Position;
                        alignment: Alignment;
                        invert: boolean;
                        animate: boolean;
                        rectangleDivider: boolean;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        imageSm: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        video: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        videoSm: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        text?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        cta2?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        blockCta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "TextWithCtaBlock";
                        title?: string | null | undefined;
                        align: Position;
                        rectangleDivider: boolean;
                        text?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        link1?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        link2?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "TwoImageHeroBlock";
                        title?: string | null | undefined;
                        title2?: string | null | undefined;
                        invert: boolean;
                        animate: boolean;
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                            }
                          | null
                          | undefined;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        cta2?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                            }
                          | null
                          | undefined;
                        image2: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                      }
                    | null
                    | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetNavQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  revisionId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetNavQuery = {
  __typename?: "Query";
  Nav?:
    | {
        __typename?: "Nav";
        id: string;
        store: string;
        handle: string;
        items?:
          | Array<
              | {
                  __typename?: "NavItem";
                  id: string;
                  title?: string | null | undefined;
                  hidden?: boolean | null | undefined;
                  highlighted?: boolean | null | undefined;
                  href?: string | null | undefined;
                  fullPath?: string | null | undefined;
                  template?: string | null | undefined;
                  items?:
                    | Array<
                        | {
                            __typename?: "NavItem";
                            id: string;
                            title?: string | null | undefined;
                            hidden?: boolean | null | undefined;
                            highlighted?: boolean | null | undefined;
                            href?: string | null | undefined;
                            fullPath?: string | null | undefined;
                            template?: string | null | undefined;
                            items?:
                              | Array<
                                  | {
                                      __typename?: "NavItem";
                                      id: string;
                                      title?: string | null | undefined;
                                      hidden?: boolean | null | undefined;
                                      highlighted?: boolean | null | undefined;
                                      href?: string | null | undefined;
                                      fullPath?: string | null | undefined;
                                      template?: string | null | undefined;
                                      promoimage?:
                                        | {
                                            __typename?: "PromoImage";
                                            image?:
                                              | {
                                                  __typename?: "FliteImage";
                                                  uri?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                  altText?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                }
                                              | null
                                              | undefined;
                                            link?:
                                              | {
                                                  __typename?: "Link";
                                                  href: string;
                                                  text: string;
                                                }
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                    }
                                  | null
                                  | undefined
                                >
                              | null
                              | undefined;
                            promoimage?:
                              | {
                                  __typename?: "PromoImage";
                                  image?:
                                    | {
                                        __typename?: "FliteImage";
                                        uri?: string | null | undefined;
                                        altText?: string | null | undefined;
                                      }
                                    | null
                                    | undefined;
                                  link?:
                                    | {
                                        __typename?: "Link";
                                        href: string;
                                        text: string;
                                      }
                                    | null
                                    | undefined;
                                }
                              | null
                              | undefined;
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined;
                  promoimage?:
                    | {
                        __typename?: "PromoImage";
                        image?:
                          | {
                              __typename?: "FliteImage";
                              uri?: string | null | undefined;
                              altText?: string | null | undefined;
                            }
                          | null
                          | undefined;
                        link?:
                          | { __typename?: "Link"; href: string; text: string }
                          | null
                          | undefined;
                      }
                    | null
                    | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetResourceByUrlQueryVariables = Exact<{
  url: Scalars["String"]["input"];
  appliedFilters?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  campaignId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetResourceByUrlQuery = {
  __typename?: "Query";
  ResourceByURL?:
    | {
        __typename: "Collection";
        id: string;
        title: string;
        tags: Array<string>;
        descriptionHtml?: string | null | undefined;
        handle: string;
        sortOrder?: CollectionSortOrder | null | undefined;
        totalProducts?: number | null | undefined;
        matchAnyTags: boolean;
        seo: {
          __typename?: "SEO";
          title?: string | null | undefined;
          description?: string | null | undefined;
        };
        image?:
          | {
              __typename?: "Image";
              id?: string | null | undefined;
              width?: number | null | undefined;
              height?: number | null | undefined;
              originalSrc: any;
              altText?: string | null | undefined;
            }
          | null
          | undefined;
        plpBlocks?:
          | Array<
              | {
                  __typename?: "CampaignPromoBlock";
                  content?:
                    | {
                        __typename?: "ContentBlock";
                        id: string;
                        createDate?: any | null | undefined;
                        updateDate?: any | null | undefined;
                        contentType?: ContentType | null | undefined;
                        order?: number | null | undefined;
                        block?:
                          | {
                              __typename?: "ArticleBlock";
                              title?: string | null | undefined;
                              subtitle?: string | null | undefined;
                              invert: boolean;
                              position: Position;
                              alignment: Alignment;
                              reverse: boolean;
                              textPosition: Position;
                              text?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              image: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              cta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "Carousel";
                              title?: string | null | undefined;
                              size: CarouselSize;
                              cta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                  }
                                | null
                                | undefined;
                              collection?:
                                | {
                                    __typename?: "Collection";
                                    url?: string | null | undefined;
                                  }
                                | null
                                | undefined;
                              cards?:
                                | {
                                    __typename?: "CardConnection";
                                    totalCount: number;
                                    edges: Array<
                                      | {
                                          __typename?: "CardEdge";
                                          node?:
                                            | {
                                                __typename?: "Card";
                                                type?:
                                                  | CardType
                                                  | null
                                                  | undefined;
                                                content?:
                                                  | {
                                                      __typename?: "DynamicGridCard";
                                                    }
                                                  | {
                                                      __typename?: "EditorialCard";
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      image?:
                                                        | {
                                                            __typename?: "FliteImage";
                                                            uri?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            altText?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      cta?:
                                                        | {
                                                            __typename?: "Link";
                                                            href: string;
                                                            text: string;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | {
                                                      __typename?: "ProductCard";
                                                      product?:
                                                        | {
                                                            __typename?: "Product";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            title?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            subtitle?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            badge?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            handle?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            canonicalUrl?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            showPrice: boolean;
                                                            tags?:
                                                              | Array<
                                                                  | string
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                            image?:
                                                              | {
                                                                  __typename?: "Image";
                                                                  id?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  originalSrc: any;
                                                                }
                                                              | null
                                                              | undefined;
                                                            priceRange?:
                                                              | {
                                                                  __typename?: "PriceRange";
                                                                  maxVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  minVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            compareAtPriceRange?:
                                                              | {
                                                                  __typename?: "PriceRange";
                                                                  maxVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  minVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            options?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "ProductOptions";
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                        | undefined;
                                                                      values?:
                                                                        | Array<
                                                                            | string
                                                                            | null
                                                                            | undefined
                                                                          >
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                            variants?:
                                                              | {
                                                                  __typename?: "VariantConnection";
                                                                  edges?:
                                                                    | Array<
                                                                        | {
                                                                            __typename?: "VariantEdge";
                                                                            node?:
                                                                              | {
                                                                                  __typename?: "ProductVariant";
                                                                                  id?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  quantityAvailable?:
                                                                                    | number
                                                                                    | null
                                                                                    | undefined;
                                                                                  selectedOptions?:
                                                                                    | Array<
                                                                                        | {
                                                                                            __typename?: "ProductOption";
                                                                                            name?:
                                                                                              | string
                                                                                              | null
                                                                                              | undefined;
                                                                                            value?:
                                                                                              | string
                                                                                              | null
                                                                                              | undefined;
                                                                                          }
                                                                                        | null
                                                                                        | undefined
                                                                                      >
                                                                                    | null
                                                                                    | undefined;
                                                                                  price?:
                                                                                    | {
                                                                                        __typename?: "Price";
                                                                                        amount?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                        currencyCode?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                      }
                                                                                    | null
                                                                                    | undefined;
                                                                                  compareAtPrice?:
                                                                                    | {
                                                                                        __typename?: "Price";
                                                                                        amount?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                        currencyCode?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                      }
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined
                                                                      >
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined
                                    >;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "DestinationFeature";
                              mediaType?: MediaType | null | undefined;
                              title?: string | null | undefined;
                              subtitle?: string | null | undefined;
                              invert: boolean;
                              rectangleDivider: boolean;
                              image: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              imageSm: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              video: {
                                __typename?: "FliteVideo";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              videoSm: {
                                __typename?: "FliteVideo";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              collection?:
                                | {
                                    __typename?: "Collection";
                                    url?: string | null | undefined;
                                  }
                                | null
                                | undefined;
                              text?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              cta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              cta2?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              blockCta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              cards?:
                                | {
                                    __typename?: "CardConnection";
                                    totalCount: number;
                                    edges: Array<
                                      | {
                                          __typename?: "CardEdge";
                                          node?:
                                            | {
                                                __typename?: "Card";
                                                type?:
                                                  | CardType
                                                  | null
                                                  | undefined;
                                                content?:
                                                  | {
                                                      __typename?: "DynamicGridCard";
                                                    }
                                                  | {
                                                      __typename?: "EditorialCard";
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      image?:
                                                        | {
                                                            __typename?: "FliteImage";
                                                            uri?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            altText?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      cta?:
                                                        | {
                                                            __typename?: "Link";
                                                            href: string;
                                                            text: string;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | {
                                                      __typename?: "ProductCard";
                                                      product?:
                                                        | {
                                                            __typename?: "Product";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            title?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            subtitle?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            badge?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            handle?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            canonicalUrl?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            showPrice: boolean;
                                                            tags?:
                                                              | Array<
                                                                  | string
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                            image?:
                                                              | {
                                                                  __typename?: "Image";
                                                                  id?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  originalSrc: any;
                                                                }
                                                              | null
                                                              | undefined;
                                                            priceRange?:
                                                              | {
                                                                  __typename?: "PriceRange";
                                                                  maxVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  minVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            compareAtPriceRange?:
                                                              | {
                                                                  __typename?: "PriceRange";
                                                                  maxVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  minVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            options?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "ProductOptions";
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                        | undefined;
                                                                      values?:
                                                                        | Array<
                                                                            | string
                                                                            | null
                                                                            | undefined
                                                                          >
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                            variants?:
                                                              | {
                                                                  __typename?: "VariantConnection";
                                                                  edges?:
                                                                    | Array<
                                                                        | {
                                                                            __typename?: "VariantEdge";
                                                                            node?:
                                                                              | {
                                                                                  __typename?: "ProductVariant";
                                                                                  id?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  quantityAvailable?:
                                                                                    | number
                                                                                    | null
                                                                                    | undefined;
                                                                                  selectedOptions?:
                                                                                    | Array<
                                                                                        | {
                                                                                            __typename?: "ProductOption";
                                                                                            name?:
                                                                                              | string
                                                                                              | null
                                                                                              | undefined;
                                                                                            value?:
                                                                                              | string
                                                                                              | null
                                                                                              | undefined;
                                                                                          }
                                                                                        | null
                                                                                        | undefined
                                                                                      >
                                                                                    | null
                                                                                    | undefined;
                                                                                  price?:
                                                                                    | {
                                                                                        __typename?: "Price";
                                                                                        amount?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                        currencyCode?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                      }
                                                                                    | null
                                                                                    | undefined;
                                                                                  compareAtPrice?:
                                                                                    | {
                                                                                        __typename?: "Price";
                                                                                        amount?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                        currencyCode?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                      }
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined
                                                                      >
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined
                                    >;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "DynamicGrid";
                              autoscroll: boolean;
                              speed: Speed;
                              cards?:
                                | {
                                    __typename?: "CardConnection";
                                    totalCount: number;
                                    edges: Array<
                                      | {
                                          __typename?: "CardEdge";
                                          node?:
                                            | {
                                                __typename?: "Card";
                                                content?:
                                                  | {
                                                      __typename?: "DynamicGridCard";
                                                      content?:
                                                        | {
                                                            __typename?: "DynamicGridCardContent";
                                                            title?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            position: Position;
                                                            alignment: Alignment;
                                                            textAlignment?:
                                                              | Position
                                                              | null
                                                              | undefined;
                                                            invert: boolean;
                                                            image: {
                                                              __typename?: "FliteImage";
                                                              uri?:
                                                                | string
                                                                | null
                                                                | undefined;
                                                              altText?:
                                                                | string
                                                                | null
                                                                | undefined;
                                                            };
                                                            body?:
                                                              | {
                                                                  __typename?: "Markdown";
                                                                  md: string;
                                                                  html: string;
                                                                }
                                                              | null
                                                              | undefined;
                                                            cta?:
                                                              | {
                                                                  __typename?: "Link";
                                                                  href: string;
                                                                  text: string;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | {
                                                      __typename?: "EditorialCard";
                                                    }
                                                  | {
                                                      __typename?: "ProductCard";
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined
                                    >;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "FilmBlock";
                              title?: string | null | undefined;
                              video: {
                                __typename?: "FliteVideo";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              videoSm: {
                                __typename?: "FliteVideo";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              coverImage: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              coverImageSm: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                            }
                          | { __typename?: "PromoBlock" }
                          | {
                              __typename?: "QABlock";
                              question1?: string | null | undefined;
                              question2?: string | null | undefined;
                              question3?: string | null | undefined;
                              question4?: string | null | undefined;
                              invert: boolean;
                              position: Position;
                              alignment: Alignment;
                              reverse: boolean;
                              textPosition: Position;
                              answer1?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              answer2?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              answer3?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              answer4?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              image: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              cta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "RecommendationBlock";
                              title?: string | null | undefined;
                              placementId?: string | null | undefined;
                              size: CarouselSize;
                              position: Position;
                              cta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "ShopTheLook";
                              mediaType?: MediaType | null | undefined;
                              title?: string | null | undefined;
                              invert: boolean;
                              rectangleDivider: boolean;
                              image: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              imageSm: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              text?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              cta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              cta2?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              blockCta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              video: {
                                __typename?: "FliteVideo";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              videoSm: {
                                __typename?: "FliteVideo";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              collection?:
                                | {
                                    __typename?: "Collection";
                                    url?: string | null | undefined;
                                  }
                                | null
                                | undefined;
                              cards?:
                                | {
                                    __typename?: "CardConnection";
                                    totalCount: number;
                                    edges: Array<
                                      | {
                                          __typename?: "CardEdge";
                                          node?:
                                            | {
                                                __typename?: "Card";
                                                type?:
                                                  | CardType
                                                  | null
                                                  | undefined;
                                                content?:
                                                  | {
                                                      __typename?: "DynamicGridCard";
                                                    }
                                                  | {
                                                      __typename?: "EditorialCard";
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      image?:
                                                        | {
                                                            __typename?: "FliteImage";
                                                            uri?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            altText?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      cta?:
                                                        | {
                                                            __typename?: "Link";
                                                            href: string;
                                                            text: string;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | {
                                                      __typename?: "ProductCard";
                                                      product?:
                                                        | {
                                                            __typename?: "Product";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            title?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            subtitle?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            badge?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            handle?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            canonicalUrl?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            showPrice: boolean;
                                                            tags?:
                                                              | Array<
                                                                  | string
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                            image?:
                                                              | {
                                                                  __typename?: "Image";
                                                                  id?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  originalSrc: any;
                                                                }
                                                              | null
                                                              | undefined;
                                                            priceRange?:
                                                              | {
                                                                  __typename?: "PriceRange";
                                                                  maxVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  minVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            compareAtPriceRange?:
                                                              | {
                                                                  __typename?: "PriceRange";
                                                                  maxVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  minVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            options?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "ProductOptions";
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                        | undefined;
                                                                      values?:
                                                                        | Array<
                                                                            | string
                                                                            | null
                                                                            | undefined
                                                                          >
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                            variants?:
                                                              | {
                                                                  __typename?: "VariantConnection";
                                                                  edges?:
                                                                    | Array<
                                                                        | {
                                                                            __typename?: "VariantEdge";
                                                                            node?:
                                                                              | {
                                                                                  __typename?: "ProductVariant";
                                                                                  id?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  quantityAvailable?:
                                                                                    | number
                                                                                    | null
                                                                                    | undefined;
                                                                                  selectedOptions?:
                                                                                    | Array<
                                                                                        | {
                                                                                            __typename?: "ProductOption";
                                                                                            name?:
                                                                                              | string
                                                                                              | null
                                                                                              | undefined;
                                                                                            value?:
                                                                                              | string
                                                                                              | null
                                                                                              | undefined;
                                                                                          }
                                                                                        | null
                                                                                        | undefined
                                                                                      >
                                                                                    | null
                                                                                    | undefined;
                                                                                  price?:
                                                                                    | {
                                                                                        __typename?: "Price";
                                                                                        amount?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                        currencyCode?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                      }
                                                                                    | null
                                                                                    | undefined;
                                                                                  compareAtPrice?:
                                                                                    | {
                                                                                        __typename?: "Price";
                                                                                        amount?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                        currencyCode?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                      }
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined
                                                                      >
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined
                                    >;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "SingleFeatureBlock";
                              mediaType?: MediaType | null | undefined;
                              title?: string | null | undefined;
                              subtitle?: string | null | undefined;
                              position: Position;
                              alignment: Alignment;
                              invert: boolean;
                              animate: boolean;
                              rectangleDivider: boolean;
                              image: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              imageSm: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              video: {
                                __typename?: "FliteVideo";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              videoSm: {
                                __typename?: "FliteVideo";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              text?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              cta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              cta2?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              blockCta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "TextWithCtaBlock";
                              title?: string | null | undefined;
                              align: Position;
                              rectangleDivider: boolean;
                              text?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              link1?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              link2?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "TwoImageHeroBlock";
                              title?: string | null | undefined;
                              title2?: string | null | undefined;
                              invert: boolean;
                              animate: boolean;
                              cta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                  }
                                | null
                                | undefined;
                              image: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              cta2?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                  }
                                | null
                                | undefined;
                              image2: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                            }
                          | null
                          | undefined;
                      }
                    | null
                    | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | {
        __typename: "Page";
        id: string;
        theme?: PageTheme | null | undefined;
        meta?:
          | {
              __typename?: "Meta";
              title?: string | null | undefined;
              description?: string | null | undefined;
              keywords?: Array<string | null | undefined> | null | undefined;
            }
          | null
          | undefined;
        contents?:
          | Array<
              | {
                  __typename?: "ContentBlock";
                  id: string;
                  createDate?: any | null | undefined;
                  updateDate?: any | null | undefined;
                  contentType?: ContentType | null | undefined;
                  order?: number | null | undefined;
                  block?:
                    | {
                        __typename?: "ArticleBlock";
                        title?: string | null | undefined;
                        subtitle?: string | null | undefined;
                        invert: boolean;
                        position: Position;
                        alignment: Alignment;
                        reverse: boolean;
                        textPosition: Position;
                        text?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "Carousel";
                        title?: string | null | undefined;
                        size: CarouselSize;
                        cta?:
                          | { __typename?: "Link"; href: string; text: string }
                          | null
                          | undefined;
                        collection?:
                          | {
                              __typename?: "Collection";
                              url?: string | null | undefined;
                            }
                          | null
                          | undefined;
                        cards?:
                          | {
                              __typename?: "CardConnection";
                              totalCount: number;
                              edges: Array<
                                | {
                                    __typename?: "CardEdge";
                                    node?:
                                      | {
                                          __typename?: "Card";
                                          type?: CardType | null | undefined;
                                          content?:
                                            | { __typename?: "DynamicGridCard" }
                                            | {
                                                __typename?: "EditorialCard";
                                                title?:
                                                  | string
                                                  | null
                                                  | undefined;
                                                image?:
                                                  | {
                                                      __typename?: "FliteImage";
                                                      uri?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      altText?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                                cta?:
                                                  | {
                                                      __typename?: "Link";
                                                      href: string;
                                                      text: string;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | {
                                                __typename?: "ProductCard";
                                                product?:
                                                  | {
                                                      __typename?: "Product";
                                                      id?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      subtitle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      badge?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      handle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      canonicalUrl?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      showPrice: boolean;
                                                      tags?:
                                                        | Array<
                                                            | string
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      image?:
                                                        | {
                                                            __typename?: "Image";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            altText?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            originalSrc: any;
                                                          }
                                                        | null
                                                        | undefined;
                                                      priceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      compareAtPriceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      options?:
                                                        | Array<
                                                            | {
                                                                __typename?: "ProductOptions";
                                                                name?:
                                                                  | string
                                                                  | null
                                                                  | undefined;
                                                                values?:
                                                                  | Array<
                                                                      | string
                                                                      | null
                                                                      | undefined
                                                                    >
                                                                  | null
                                                                  | undefined;
                                                              }
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      variants?:
                                                        | {
                                                            __typename?: "VariantConnection";
                                                            edges?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "VariantEdge";
                                                                      node?:
                                                                        | {
                                                                            __typename?: "ProductVariant";
                                                                            id?:
                                                                              | string
                                                                              | null
                                                                              | undefined;
                                                                            quantityAvailable?:
                                                                              | number
                                                                              | null
                                                                              | undefined;
                                                                            selectedOptions?:
                                                                              | Array<
                                                                                  | {
                                                                                      __typename?: "ProductOption";
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                      value?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                    }
                                                                                  | null
                                                                                  | undefined
                                                                                >
                                                                              | null
                                                                              | undefined;
                                                                            price?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                            compareAtPrice?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | null
                                | undefined
                              >;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "DestinationFeature";
                        mediaType?: MediaType | null | undefined;
                        title?: string | null | undefined;
                        subtitle?: string | null | undefined;
                        invert: boolean;
                        rectangleDivider: boolean;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        imageSm: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        video: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        videoSm: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        collection?:
                          | {
                              __typename?: "Collection";
                              url?: string | null | undefined;
                            }
                          | null
                          | undefined;
                        text?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        cta2?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        blockCta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        cards?:
                          | {
                              __typename?: "CardConnection";
                              totalCount: number;
                              edges: Array<
                                | {
                                    __typename?: "CardEdge";
                                    node?:
                                      | {
                                          __typename?: "Card";
                                          type?: CardType | null | undefined;
                                          content?:
                                            | { __typename?: "DynamicGridCard" }
                                            | {
                                                __typename?: "EditorialCard";
                                                title?:
                                                  | string
                                                  | null
                                                  | undefined;
                                                image?:
                                                  | {
                                                      __typename?: "FliteImage";
                                                      uri?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      altText?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                                cta?:
                                                  | {
                                                      __typename?: "Link";
                                                      href: string;
                                                      text: string;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | {
                                                __typename?: "ProductCard";
                                                product?:
                                                  | {
                                                      __typename?: "Product";
                                                      id?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      subtitle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      badge?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      handle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      canonicalUrl?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      showPrice: boolean;
                                                      tags?:
                                                        | Array<
                                                            | string
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      image?:
                                                        | {
                                                            __typename?: "Image";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            altText?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            originalSrc: any;
                                                          }
                                                        | null
                                                        | undefined;
                                                      priceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      compareAtPriceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      options?:
                                                        | Array<
                                                            | {
                                                                __typename?: "ProductOptions";
                                                                name?:
                                                                  | string
                                                                  | null
                                                                  | undefined;
                                                                values?:
                                                                  | Array<
                                                                      | string
                                                                      | null
                                                                      | undefined
                                                                    >
                                                                  | null
                                                                  | undefined;
                                                              }
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      variants?:
                                                        | {
                                                            __typename?: "VariantConnection";
                                                            edges?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "VariantEdge";
                                                                      node?:
                                                                        | {
                                                                            __typename?: "ProductVariant";
                                                                            id?:
                                                                              | string
                                                                              | null
                                                                              | undefined;
                                                                            quantityAvailable?:
                                                                              | number
                                                                              | null
                                                                              | undefined;
                                                                            selectedOptions?:
                                                                              | Array<
                                                                                  | {
                                                                                      __typename?: "ProductOption";
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                      value?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                    }
                                                                                  | null
                                                                                  | undefined
                                                                                >
                                                                              | null
                                                                              | undefined;
                                                                            price?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                            compareAtPrice?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | null
                                | undefined
                              >;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "DynamicGrid";
                        autoscroll: boolean;
                        speed: Speed;
                        cards?:
                          | {
                              __typename?: "CardConnection";
                              totalCount: number;
                              edges: Array<
                                | {
                                    __typename?: "CardEdge";
                                    node?:
                                      | {
                                          __typename?: "Card";
                                          content?:
                                            | {
                                                __typename?: "DynamicGridCard";
                                                content?:
                                                  | {
                                                      __typename?: "DynamicGridCardContent";
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      position: Position;
                                                      alignment: Alignment;
                                                      textAlignment?:
                                                        | Position
                                                        | null
                                                        | undefined;
                                                      invert: boolean;
                                                      image: {
                                                        __typename?: "FliteImage";
                                                        uri?:
                                                          | string
                                                          | null
                                                          | undefined;
                                                        altText?:
                                                          | string
                                                          | null
                                                          | undefined;
                                                      };
                                                      body?:
                                                        | {
                                                            __typename?: "Markdown";
                                                            md: string;
                                                            html: string;
                                                          }
                                                        | null
                                                        | undefined;
                                                      cta?:
                                                        | {
                                                            __typename?: "Link";
                                                            href: string;
                                                            text: string;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | { __typename?: "EditorialCard" }
                                            | { __typename?: "ProductCard" }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | null
                                | undefined
                              >;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "FilmBlock";
                        title?: string | null | undefined;
                        video: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        videoSm: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        coverImage: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        coverImageSm: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                      }
                    | { __typename?: "PromoBlock" }
                    | {
                        __typename?: "QABlock";
                        question1?: string | null | undefined;
                        question2?: string | null | undefined;
                        question3?: string | null | undefined;
                        question4?: string | null | undefined;
                        invert: boolean;
                        position: Position;
                        alignment: Alignment;
                        reverse: boolean;
                        textPosition: Position;
                        answer1?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        answer2?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        answer3?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        answer4?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "RecommendationBlock";
                        title?: string | null | undefined;
                        placementId?: string | null | undefined;
                        size: CarouselSize;
                        position: Position;
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "ShopTheLook";
                        mediaType?: MediaType | null | undefined;
                        title?: string | null | undefined;
                        invert: boolean;
                        rectangleDivider: boolean;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        imageSm: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        text?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        cta2?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        blockCta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        video: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        videoSm: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        collection?:
                          | {
                              __typename?: "Collection";
                              url?: string | null | undefined;
                            }
                          | null
                          | undefined;
                        cards?:
                          | {
                              __typename?: "CardConnection";
                              totalCount: number;
                              edges: Array<
                                | {
                                    __typename?: "CardEdge";
                                    node?:
                                      | {
                                          __typename?: "Card";
                                          type?: CardType | null | undefined;
                                          content?:
                                            | { __typename?: "DynamicGridCard" }
                                            | {
                                                __typename?: "EditorialCard";
                                                title?:
                                                  | string
                                                  | null
                                                  | undefined;
                                                image?:
                                                  | {
                                                      __typename?: "FliteImage";
                                                      uri?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      altText?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                                cta?:
                                                  | {
                                                      __typename?: "Link";
                                                      href: string;
                                                      text: string;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | {
                                                __typename?: "ProductCard";
                                                product?:
                                                  | {
                                                      __typename?: "Product";
                                                      id?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      subtitle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      badge?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      handle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      canonicalUrl?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      showPrice: boolean;
                                                      tags?:
                                                        | Array<
                                                            | string
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      image?:
                                                        | {
                                                            __typename?: "Image";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            altText?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            originalSrc: any;
                                                          }
                                                        | null
                                                        | undefined;
                                                      priceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      compareAtPriceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      options?:
                                                        | Array<
                                                            | {
                                                                __typename?: "ProductOptions";
                                                                name?:
                                                                  | string
                                                                  | null
                                                                  | undefined;
                                                                values?:
                                                                  | Array<
                                                                      | string
                                                                      | null
                                                                      | undefined
                                                                    >
                                                                  | null
                                                                  | undefined;
                                                              }
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      variants?:
                                                        | {
                                                            __typename?: "VariantConnection";
                                                            edges?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "VariantEdge";
                                                                      node?:
                                                                        | {
                                                                            __typename?: "ProductVariant";
                                                                            id?:
                                                                              | string
                                                                              | null
                                                                              | undefined;
                                                                            quantityAvailable?:
                                                                              | number
                                                                              | null
                                                                              | undefined;
                                                                            selectedOptions?:
                                                                              | Array<
                                                                                  | {
                                                                                      __typename?: "ProductOption";
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                      value?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                    }
                                                                                  | null
                                                                                  | undefined
                                                                                >
                                                                              | null
                                                                              | undefined;
                                                                            price?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                            compareAtPrice?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | null
                                | undefined
                              >;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "SingleFeatureBlock";
                        mediaType?: MediaType | null | undefined;
                        title?: string | null | undefined;
                        subtitle?: string | null | undefined;
                        position: Position;
                        alignment: Alignment;
                        invert: boolean;
                        animate: boolean;
                        rectangleDivider: boolean;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        imageSm: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        video: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        videoSm: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        text?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        cta2?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        blockCta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "TextWithCtaBlock";
                        title?: string | null | undefined;
                        align: Position;
                        rectangleDivider: boolean;
                        text?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        link1?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        link2?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "TwoImageHeroBlock";
                        title?: string | null | undefined;
                        title2?: string | null | undefined;
                        invert: boolean;
                        animate: boolean;
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                            }
                          | null
                          | undefined;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        cta2?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                            }
                          | null
                          | undefined;
                        image2: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                      }
                    | null
                    | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CoreCollectionFieldsFragment = {
  __typename?: "Collection";
  id: string;
  title: string;
  tags: Array<string>;
  descriptionHtml?: string | null | undefined;
  handle: string;
  sortOrder?: CollectionSortOrder | null | undefined;
  totalProducts?: number | null | undefined;
  matchAnyTags: boolean;
  seo: {
    __typename?: "SEO";
    title?: string | null | undefined;
    description?: string | null | undefined;
  };
  image?:
    | {
        __typename?: "Image";
        id?: string | null | undefined;
        width?: number | null | undefined;
        height?: number | null | undefined;
        originalSrc: any;
        altText?: string | null | undefined;
      }
    | null
    | undefined;
};

export type CollectionBlocksFragment = {
  __typename?: "Collection";
  plpBlocks?:
    | Array<
        | {
            __typename?: "CampaignPromoBlock";
            content?:
              | {
                  __typename?: "ContentBlock";
                  id: string;
                  createDate?: any | null | undefined;
                  updateDate?: any | null | undefined;
                  contentType?: ContentType | null | undefined;
                  order?: number | null | undefined;
                  block?:
                    | {
                        __typename?: "ArticleBlock";
                        title?: string | null | undefined;
                        subtitle?: string | null | undefined;
                        invert: boolean;
                        position: Position;
                        alignment: Alignment;
                        reverse: boolean;
                        textPosition: Position;
                        text?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "Carousel";
                        title?: string | null | undefined;
                        size: CarouselSize;
                        cta?:
                          | { __typename?: "Link"; href: string; text: string }
                          | null
                          | undefined;
                        collection?:
                          | {
                              __typename?: "Collection";
                              url?: string | null | undefined;
                            }
                          | null
                          | undefined;
                        cards?:
                          | {
                              __typename?: "CardConnection";
                              totalCount: number;
                              edges: Array<
                                | {
                                    __typename?: "CardEdge";
                                    node?:
                                      | {
                                          __typename?: "Card";
                                          type?: CardType | null | undefined;
                                          content?:
                                            | { __typename?: "DynamicGridCard" }
                                            | {
                                                __typename?: "EditorialCard";
                                                title?:
                                                  | string
                                                  | null
                                                  | undefined;
                                                image?:
                                                  | {
                                                      __typename?: "FliteImage";
                                                      uri?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      altText?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                                cta?:
                                                  | {
                                                      __typename?: "Link";
                                                      href: string;
                                                      text: string;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | {
                                                __typename?: "ProductCard";
                                                product?:
                                                  | {
                                                      __typename?: "Product";
                                                      id?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      subtitle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      badge?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      handle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      canonicalUrl?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      showPrice: boolean;
                                                      tags?:
                                                        | Array<
                                                            | string
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      image?:
                                                        | {
                                                            __typename?: "Image";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            altText?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            originalSrc: any;
                                                          }
                                                        | null
                                                        | undefined;
                                                      priceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      compareAtPriceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      options?:
                                                        | Array<
                                                            | {
                                                                __typename?: "ProductOptions";
                                                                name?:
                                                                  | string
                                                                  | null
                                                                  | undefined;
                                                                values?:
                                                                  | Array<
                                                                      | string
                                                                      | null
                                                                      | undefined
                                                                    >
                                                                  | null
                                                                  | undefined;
                                                              }
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      variants?:
                                                        | {
                                                            __typename?: "VariantConnection";
                                                            edges?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "VariantEdge";
                                                                      node?:
                                                                        | {
                                                                            __typename?: "ProductVariant";
                                                                            id?:
                                                                              | string
                                                                              | null
                                                                              | undefined;
                                                                            quantityAvailable?:
                                                                              | number
                                                                              | null
                                                                              | undefined;
                                                                            selectedOptions?:
                                                                              | Array<
                                                                                  | {
                                                                                      __typename?: "ProductOption";
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                      value?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                    }
                                                                                  | null
                                                                                  | undefined
                                                                                >
                                                                              | null
                                                                              | undefined;
                                                                            price?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                            compareAtPrice?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | null
                                | undefined
                              >;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "DestinationFeature";
                        mediaType?: MediaType | null | undefined;
                        title?: string | null | undefined;
                        subtitle?: string | null | undefined;
                        invert: boolean;
                        rectangleDivider: boolean;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        imageSm: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        video: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        videoSm: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        collection?:
                          | {
                              __typename?: "Collection";
                              url?: string | null | undefined;
                            }
                          | null
                          | undefined;
                        text?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        cta2?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        blockCta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        cards?:
                          | {
                              __typename?: "CardConnection";
                              totalCount: number;
                              edges: Array<
                                | {
                                    __typename?: "CardEdge";
                                    node?:
                                      | {
                                          __typename?: "Card";
                                          type?: CardType | null | undefined;
                                          content?:
                                            | { __typename?: "DynamicGridCard" }
                                            | {
                                                __typename?: "EditorialCard";
                                                title?:
                                                  | string
                                                  | null
                                                  | undefined;
                                                image?:
                                                  | {
                                                      __typename?: "FliteImage";
                                                      uri?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      altText?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                                cta?:
                                                  | {
                                                      __typename?: "Link";
                                                      href: string;
                                                      text: string;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | {
                                                __typename?: "ProductCard";
                                                product?:
                                                  | {
                                                      __typename?: "Product";
                                                      id?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      subtitle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      badge?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      handle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      canonicalUrl?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      showPrice: boolean;
                                                      tags?:
                                                        | Array<
                                                            | string
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      image?:
                                                        | {
                                                            __typename?: "Image";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            altText?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            originalSrc: any;
                                                          }
                                                        | null
                                                        | undefined;
                                                      priceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      compareAtPriceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      options?:
                                                        | Array<
                                                            | {
                                                                __typename?: "ProductOptions";
                                                                name?:
                                                                  | string
                                                                  | null
                                                                  | undefined;
                                                                values?:
                                                                  | Array<
                                                                      | string
                                                                      | null
                                                                      | undefined
                                                                    >
                                                                  | null
                                                                  | undefined;
                                                              }
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      variants?:
                                                        | {
                                                            __typename?: "VariantConnection";
                                                            edges?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "VariantEdge";
                                                                      node?:
                                                                        | {
                                                                            __typename?: "ProductVariant";
                                                                            id?:
                                                                              | string
                                                                              | null
                                                                              | undefined;
                                                                            quantityAvailable?:
                                                                              | number
                                                                              | null
                                                                              | undefined;
                                                                            selectedOptions?:
                                                                              | Array<
                                                                                  | {
                                                                                      __typename?: "ProductOption";
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                      value?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                    }
                                                                                  | null
                                                                                  | undefined
                                                                                >
                                                                              | null
                                                                              | undefined;
                                                                            price?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                            compareAtPrice?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | null
                                | undefined
                              >;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "DynamicGrid";
                        autoscroll: boolean;
                        speed: Speed;
                        cards?:
                          | {
                              __typename?: "CardConnection";
                              totalCount: number;
                              edges: Array<
                                | {
                                    __typename?: "CardEdge";
                                    node?:
                                      | {
                                          __typename?: "Card";
                                          content?:
                                            | {
                                                __typename?: "DynamicGridCard";
                                                content?:
                                                  | {
                                                      __typename?: "DynamicGridCardContent";
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      position: Position;
                                                      alignment: Alignment;
                                                      textAlignment?:
                                                        | Position
                                                        | null
                                                        | undefined;
                                                      invert: boolean;
                                                      image: {
                                                        __typename?: "FliteImage";
                                                        uri?:
                                                          | string
                                                          | null
                                                          | undefined;
                                                        altText?:
                                                          | string
                                                          | null
                                                          | undefined;
                                                      };
                                                      body?:
                                                        | {
                                                            __typename?: "Markdown";
                                                            md: string;
                                                            html: string;
                                                          }
                                                        | null
                                                        | undefined;
                                                      cta?:
                                                        | {
                                                            __typename?: "Link";
                                                            href: string;
                                                            text: string;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | { __typename?: "EditorialCard" }
                                            | { __typename?: "ProductCard" }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | null
                                | undefined
                              >;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "FilmBlock";
                        title?: string | null | undefined;
                        video: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        videoSm: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        coverImage: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        coverImageSm: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                      }
                    | { __typename?: "PromoBlock" }
                    | {
                        __typename?: "QABlock";
                        question1?: string | null | undefined;
                        question2?: string | null | undefined;
                        question3?: string | null | undefined;
                        question4?: string | null | undefined;
                        invert: boolean;
                        position: Position;
                        alignment: Alignment;
                        reverse: boolean;
                        textPosition: Position;
                        answer1?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        answer2?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        answer3?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        answer4?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "RecommendationBlock";
                        title?: string | null | undefined;
                        placementId?: string | null | undefined;
                        size: CarouselSize;
                        position: Position;
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "ShopTheLook";
                        mediaType?: MediaType | null | undefined;
                        title?: string | null | undefined;
                        invert: boolean;
                        rectangleDivider: boolean;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        imageSm: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        text?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        cta2?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        blockCta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        video: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        videoSm: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        collection?:
                          | {
                              __typename?: "Collection";
                              url?: string | null | undefined;
                            }
                          | null
                          | undefined;
                        cards?:
                          | {
                              __typename?: "CardConnection";
                              totalCount: number;
                              edges: Array<
                                | {
                                    __typename?: "CardEdge";
                                    node?:
                                      | {
                                          __typename?: "Card";
                                          type?: CardType | null | undefined;
                                          content?:
                                            | { __typename?: "DynamicGridCard" }
                                            | {
                                                __typename?: "EditorialCard";
                                                title?:
                                                  | string
                                                  | null
                                                  | undefined;
                                                image?:
                                                  | {
                                                      __typename?: "FliteImage";
                                                      uri?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      altText?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                                cta?:
                                                  | {
                                                      __typename?: "Link";
                                                      href: string;
                                                      text: string;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | {
                                                __typename?: "ProductCard";
                                                product?:
                                                  | {
                                                      __typename?: "Product";
                                                      id?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      subtitle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      badge?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      handle?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      canonicalUrl?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      showPrice: boolean;
                                                      tags?:
                                                        | Array<
                                                            | string
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      image?:
                                                        | {
                                                            __typename?: "Image";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            altText?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            originalSrc: any;
                                                          }
                                                        | null
                                                        | undefined;
                                                      priceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      compareAtPriceRange?:
                                                        | {
                                                            __typename?: "PriceRange";
                                                            maxVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            minVariantPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      options?:
                                                        | Array<
                                                            | {
                                                                __typename?: "ProductOptions";
                                                                name?:
                                                                  | string
                                                                  | null
                                                                  | undefined;
                                                                values?:
                                                                  | Array<
                                                                      | string
                                                                      | null
                                                                      | undefined
                                                                    >
                                                                  | null
                                                                  | undefined;
                                                              }
                                                            | null
                                                            | undefined
                                                          >
                                                        | null
                                                        | undefined;
                                                      variants?:
                                                        | {
                                                            __typename?: "VariantConnection";
                                                            edges?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "VariantEdge";
                                                                      node?:
                                                                        | {
                                                                            __typename?: "ProductVariant";
                                                                            id?:
                                                                              | string
                                                                              | null
                                                                              | undefined;
                                                                            quantityAvailable?:
                                                                              | number
                                                                              | null
                                                                              | undefined;
                                                                            selectedOptions?:
                                                                              | Array<
                                                                                  | {
                                                                                      __typename?: "ProductOption";
                                                                                      name?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                      value?:
                                                                                        | string
                                                                                        | null
                                                                                        | undefined;
                                                                                    }
                                                                                  | null
                                                                                  | undefined
                                                                                >
                                                                              | null
                                                                              | undefined;
                                                                            price?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                            compareAtPrice?:
                                                                              | {
                                                                                  __typename?: "Price";
                                                                                  amount?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  currencyCode?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | null
                                | undefined
                              >;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "SingleFeatureBlock";
                        mediaType?: MediaType | null | undefined;
                        title?: string | null | undefined;
                        subtitle?: string | null | undefined;
                        position: Position;
                        alignment: Alignment;
                        invert: boolean;
                        animate: boolean;
                        rectangleDivider: boolean;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        imageSm: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        video: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        videoSm: {
                          __typename?: "FliteVideo";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        text?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        cta2?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        blockCta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "TextWithCtaBlock";
                        title?: string | null | undefined;
                        align: Position;
                        rectangleDivider: boolean;
                        text?:
                          | {
                              __typename?: "Markdown";
                              md: string;
                              html: string;
                            }
                          | null
                          | undefined;
                        link1?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                        link2?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                              textLight?: boolean | null | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | {
                        __typename?: "TwoImageHeroBlock";
                        title?: string | null | undefined;
                        title2?: string | null | undefined;
                        invert: boolean;
                        animate: boolean;
                        cta?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                            }
                          | null
                          | undefined;
                        image: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                        cta2?:
                          | {
                              __typename?: "Link";
                              href: string;
                              text: string;
                              bgColour?: string | null | undefined;
                            }
                          | null
                          | undefined;
                        image2: {
                          __typename?: "FliteImage";
                          uri?: string | null | undefined;
                          altText?: string | null | undefined;
                        };
                      }
                    | null
                    | undefined;
                }
              | null
              | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type ContentBlocksFragment = {
  __typename?: "ContentBlock";
  id: string;
  createDate?: any | null | undefined;
  updateDate?: any | null | undefined;
  contentType?: ContentType | null | undefined;
  order?: number | null | undefined;
  block?:
    | {
        __typename?: "ArticleBlock";
        title?: string | null | undefined;
        subtitle?: string | null | undefined;
        invert: boolean;
        position: Position;
        alignment: Alignment;
        reverse: boolean;
        textPosition: Position;
        text?:
          | { __typename?: "Markdown"; md: string; html: string }
          | null
          | undefined;
        image: {
          __typename?: "FliteImage";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        cta?:
          | {
              __typename?: "Link";
              href: string;
              text: string;
              bgColour?: string | null | undefined;
              textLight?: boolean | null | undefined;
            }
          | null
          | undefined;
      }
    | {
        __typename?: "Carousel";
        title?: string | null | undefined;
        size: CarouselSize;
        cta?:
          | { __typename?: "Link"; href: string; text: string }
          | null
          | undefined;
        collection?:
          | { __typename?: "Collection"; url?: string | null | undefined }
          | null
          | undefined;
        cards?:
          | {
              __typename?: "CardConnection";
              totalCount: number;
              edges: Array<
                | {
                    __typename?: "CardEdge";
                    node?:
                      | {
                          __typename?: "Card";
                          type?: CardType | null | undefined;
                          content?:
                            | { __typename?: "DynamicGridCard" }
                            | {
                                __typename?: "EditorialCard";
                                title?: string | null | undefined;
                                image?:
                                  | {
                                      __typename?: "FliteImage";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    }
                                  | null
                                  | undefined;
                                cta?:
                                  | {
                                      __typename?: "Link";
                                      href: string;
                                      text: string;
                                    }
                                  | null
                                  | undefined;
                              }
                            | {
                                __typename?: "ProductCard";
                                product?:
                                  | {
                                      __typename?: "Product";
                                      id?: string | null | undefined;
                                      title?: string | null | undefined;
                                      subtitle?: string | null | undefined;
                                      badge?: string | null | undefined;
                                      handle?: string | null | undefined;
                                      canonicalUrl?: string | null | undefined;
                                      showPrice: boolean;
                                      tags?:
                                        | Array<string | null | undefined>
                                        | null
                                        | undefined;
                                      image?:
                                        | {
                                            __typename?: "Image";
                                            id?: string | null | undefined;
                                            altText?: string | null | undefined;
                                            originalSrc: any;
                                          }
                                        | null
                                        | undefined;
                                      priceRange?:
                                        | {
                                            __typename?: "PriceRange";
                                            maxVariantPrice?:
                                              | {
                                                  __typename?: "Price";
                                                  amount?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                  currencyCode?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                }
                                              | null
                                              | undefined;
                                            minVariantPrice?:
                                              | {
                                                  __typename?: "Price";
                                                  amount?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                  currencyCode?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                }
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                      compareAtPriceRange?:
                                        | {
                                            __typename?: "PriceRange";
                                            maxVariantPrice?:
                                              | {
                                                  __typename?: "Price";
                                                  amount?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                  currencyCode?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                }
                                              | null
                                              | undefined;
                                            minVariantPrice?:
                                              | {
                                                  __typename?: "Price";
                                                  amount?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                  currencyCode?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                }
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                      options?:
                                        | Array<
                                            | {
                                                __typename?: "ProductOptions";
                                                name?:
                                                  | string
                                                  | null
                                                  | undefined;
                                                values?:
                                                  | Array<
                                                      string | null | undefined
                                                    >
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined
                                          >
                                        | null
                                        | undefined;
                                      variants?:
                                        | {
                                            __typename?: "VariantConnection";
                                            edges?:
                                              | Array<
                                                  | {
                                                      __typename?: "VariantEdge";
                                                      node?:
                                                        | {
                                                            __typename?: "ProductVariant";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            quantityAvailable?:
                                                              | number
                                                              | null
                                                              | undefined;
                                                            selectedOptions?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "ProductOption";
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                        | undefined;
                                                                      value?:
                                                                        | string
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                            price?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            compareAtPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined
                                                >
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                    }
                                  | null
                                  | undefined;
                              }
                            | null
                            | undefined;
                        }
                      | null
                      | undefined;
                  }
                | null
                | undefined
              >;
            }
          | null
          | undefined;
      }
    | {
        __typename?: "DestinationFeature";
        mediaType?: MediaType | null | undefined;
        title?: string | null | undefined;
        subtitle?: string | null | undefined;
        invert: boolean;
        rectangleDivider: boolean;
        image: {
          __typename?: "FliteImage";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        imageSm: {
          __typename?: "FliteImage";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        video: {
          __typename?: "FliteVideo";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        videoSm: {
          __typename?: "FliteVideo";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        collection?:
          | { __typename?: "Collection"; url?: string | null | undefined }
          | null
          | undefined;
        text?:
          | { __typename?: "Markdown"; md: string; html: string }
          | null
          | undefined;
        cta?:
          | {
              __typename?: "Link";
              href: string;
              text: string;
              bgColour?: string | null | undefined;
              textLight?: boolean | null | undefined;
            }
          | null
          | undefined;
        cta2?:
          | {
              __typename?: "Link";
              href: string;
              text: string;
              bgColour?: string | null | undefined;
              textLight?: boolean | null | undefined;
            }
          | null
          | undefined;
        blockCta?:
          | {
              __typename?: "Link";
              href: string;
              text: string;
              bgColour?: string | null | undefined;
              textLight?: boolean | null | undefined;
            }
          | null
          | undefined;
        cards?:
          | {
              __typename?: "CardConnection";
              totalCount: number;
              edges: Array<
                | {
                    __typename?: "CardEdge";
                    node?:
                      | {
                          __typename?: "Card";
                          type?: CardType | null | undefined;
                          content?:
                            | { __typename?: "DynamicGridCard" }
                            | {
                                __typename?: "EditorialCard";
                                title?: string | null | undefined;
                                image?:
                                  | {
                                      __typename?: "FliteImage";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    }
                                  | null
                                  | undefined;
                                cta?:
                                  | {
                                      __typename?: "Link";
                                      href: string;
                                      text: string;
                                    }
                                  | null
                                  | undefined;
                              }
                            | {
                                __typename?: "ProductCard";
                                product?:
                                  | {
                                      __typename?: "Product";
                                      id?: string | null | undefined;
                                      title?: string | null | undefined;
                                      subtitle?: string | null | undefined;
                                      badge?: string | null | undefined;
                                      handle?: string | null | undefined;
                                      canonicalUrl?: string | null | undefined;
                                      showPrice: boolean;
                                      tags?:
                                        | Array<string | null | undefined>
                                        | null
                                        | undefined;
                                      image?:
                                        | {
                                            __typename?: "Image";
                                            id?: string | null | undefined;
                                            altText?: string | null | undefined;
                                            originalSrc: any;
                                          }
                                        | null
                                        | undefined;
                                      priceRange?:
                                        | {
                                            __typename?: "PriceRange";
                                            maxVariantPrice?:
                                              | {
                                                  __typename?: "Price";
                                                  amount?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                  currencyCode?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                }
                                              | null
                                              | undefined;
                                            minVariantPrice?:
                                              | {
                                                  __typename?: "Price";
                                                  amount?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                  currencyCode?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                }
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                      compareAtPriceRange?:
                                        | {
                                            __typename?: "PriceRange";
                                            maxVariantPrice?:
                                              | {
                                                  __typename?: "Price";
                                                  amount?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                  currencyCode?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                }
                                              | null
                                              | undefined;
                                            minVariantPrice?:
                                              | {
                                                  __typename?: "Price";
                                                  amount?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                  currencyCode?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                }
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                      options?:
                                        | Array<
                                            | {
                                                __typename?: "ProductOptions";
                                                name?:
                                                  | string
                                                  | null
                                                  | undefined;
                                                values?:
                                                  | Array<
                                                      string | null | undefined
                                                    >
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined
                                          >
                                        | null
                                        | undefined;
                                      variants?:
                                        | {
                                            __typename?: "VariantConnection";
                                            edges?:
                                              | Array<
                                                  | {
                                                      __typename?: "VariantEdge";
                                                      node?:
                                                        | {
                                                            __typename?: "ProductVariant";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            quantityAvailable?:
                                                              | number
                                                              | null
                                                              | undefined;
                                                            selectedOptions?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "ProductOption";
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                        | undefined;
                                                                      value?:
                                                                        | string
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                            price?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            compareAtPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined
                                                >
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                    }
                                  | null
                                  | undefined;
                              }
                            | null
                            | undefined;
                        }
                      | null
                      | undefined;
                  }
                | null
                | undefined
              >;
            }
          | null
          | undefined;
      }
    | {
        __typename?: "DynamicGrid";
        autoscroll: boolean;
        speed: Speed;
        cards?:
          | {
              __typename?: "CardConnection";
              totalCount: number;
              edges: Array<
                | {
                    __typename?: "CardEdge";
                    node?:
                      | {
                          __typename?: "Card";
                          content?:
                            | {
                                __typename?: "DynamicGridCard";
                                content?:
                                  | {
                                      __typename?: "DynamicGridCardContent";
                                      title?: string | null | undefined;
                                      position: Position;
                                      alignment: Alignment;
                                      textAlignment?:
                                        | Position
                                        | null
                                        | undefined;
                                      invert: boolean;
                                      image: {
                                        __typename?: "FliteImage";
                                        uri?: string | null | undefined;
                                        altText?: string | null | undefined;
                                      };
                                      body?:
                                        | {
                                            __typename?: "Markdown";
                                            md: string;
                                            html: string;
                                          }
                                        | null
                                        | undefined;
                                      cta?:
                                        | {
                                            __typename?: "Link";
                                            href: string;
                                            text: string;
                                          }
                                        | null
                                        | undefined;
                                    }
                                  | null
                                  | undefined;
                              }
                            | { __typename?: "EditorialCard" }
                            | { __typename?: "ProductCard" }
                            | null
                            | undefined;
                        }
                      | null
                      | undefined;
                  }
                | null
                | undefined
              >;
            }
          | null
          | undefined;
      }
    | {
        __typename?: "FilmBlock";
        title?: string | null | undefined;
        video: {
          __typename?: "FliteVideo";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        videoSm: {
          __typename?: "FliteVideo";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        coverImage: {
          __typename?: "FliteImage";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        coverImageSm: {
          __typename?: "FliteImage";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
      }
    | { __typename?: "PromoBlock" }
    | {
        __typename?: "QABlock";
        question1?: string | null | undefined;
        question2?: string | null | undefined;
        question3?: string | null | undefined;
        question4?: string | null | undefined;
        invert: boolean;
        position: Position;
        alignment: Alignment;
        reverse: boolean;
        textPosition: Position;
        answer1?:
          | { __typename?: "Markdown"; md: string; html: string }
          | null
          | undefined;
        answer2?:
          | { __typename?: "Markdown"; md: string; html: string }
          | null
          | undefined;
        answer3?:
          | { __typename?: "Markdown"; md: string; html: string }
          | null
          | undefined;
        answer4?:
          | { __typename?: "Markdown"; md: string; html: string }
          | null
          | undefined;
        image: {
          __typename?: "FliteImage";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        cta?:
          | {
              __typename?: "Link";
              href: string;
              text: string;
              bgColour?: string | null | undefined;
              textLight?: boolean | null | undefined;
            }
          | null
          | undefined;
      }
    | {
        __typename?: "RecommendationBlock";
        title?: string | null | undefined;
        placementId?: string | null | undefined;
        size: CarouselSize;
        position: Position;
        cta?:
          | {
              __typename?: "Link";
              href: string;
              text: string;
              bgColour?: string | null | undefined;
              textLight?: boolean | null | undefined;
            }
          | null
          | undefined;
      }
    | {
        __typename?: "ShopTheLook";
        mediaType?: MediaType | null | undefined;
        title?: string | null | undefined;
        invert: boolean;
        rectangleDivider: boolean;
        image: {
          __typename?: "FliteImage";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        imageSm: {
          __typename?: "FliteImage";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        text?:
          | { __typename?: "Markdown"; md: string; html: string }
          | null
          | undefined;
        cta?:
          | {
              __typename?: "Link";
              href: string;
              text: string;
              bgColour?: string | null | undefined;
              textLight?: boolean | null | undefined;
            }
          | null
          | undefined;
        cta2?:
          | {
              __typename?: "Link";
              href: string;
              text: string;
              bgColour?: string | null | undefined;
              textLight?: boolean | null | undefined;
            }
          | null
          | undefined;
        blockCta?:
          | {
              __typename?: "Link";
              href: string;
              text: string;
              bgColour?: string | null | undefined;
              textLight?: boolean | null | undefined;
            }
          | null
          | undefined;
        video: {
          __typename?: "FliteVideo";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        videoSm: {
          __typename?: "FliteVideo";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        collection?:
          | { __typename?: "Collection"; url?: string | null | undefined }
          | null
          | undefined;
        cards?:
          | {
              __typename?: "CardConnection";
              totalCount: number;
              edges: Array<
                | {
                    __typename?: "CardEdge";
                    node?:
                      | {
                          __typename?: "Card";
                          type?: CardType | null | undefined;
                          content?:
                            | { __typename?: "DynamicGridCard" }
                            | {
                                __typename?: "EditorialCard";
                                title?: string | null | undefined;
                                image?:
                                  | {
                                      __typename?: "FliteImage";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    }
                                  | null
                                  | undefined;
                                cta?:
                                  | {
                                      __typename?: "Link";
                                      href: string;
                                      text: string;
                                    }
                                  | null
                                  | undefined;
                              }
                            | {
                                __typename?: "ProductCard";
                                product?:
                                  | {
                                      __typename?: "Product";
                                      id?: string | null | undefined;
                                      title?: string | null | undefined;
                                      subtitle?: string | null | undefined;
                                      badge?: string | null | undefined;
                                      handle?: string | null | undefined;
                                      canonicalUrl?: string | null | undefined;
                                      showPrice: boolean;
                                      tags?:
                                        | Array<string | null | undefined>
                                        | null
                                        | undefined;
                                      image?:
                                        | {
                                            __typename?: "Image";
                                            id?: string | null | undefined;
                                            altText?: string | null | undefined;
                                            originalSrc: any;
                                          }
                                        | null
                                        | undefined;
                                      priceRange?:
                                        | {
                                            __typename?: "PriceRange";
                                            maxVariantPrice?:
                                              | {
                                                  __typename?: "Price";
                                                  amount?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                  currencyCode?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                }
                                              | null
                                              | undefined;
                                            minVariantPrice?:
                                              | {
                                                  __typename?: "Price";
                                                  amount?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                  currencyCode?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                }
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                      compareAtPriceRange?:
                                        | {
                                            __typename?: "PriceRange";
                                            maxVariantPrice?:
                                              | {
                                                  __typename?: "Price";
                                                  amount?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                  currencyCode?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                }
                                              | null
                                              | undefined;
                                            minVariantPrice?:
                                              | {
                                                  __typename?: "Price";
                                                  amount?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                  currencyCode?:
                                                    | string
                                                    | null
                                                    | undefined;
                                                }
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                      options?:
                                        | Array<
                                            | {
                                                __typename?: "ProductOptions";
                                                name?:
                                                  | string
                                                  | null
                                                  | undefined;
                                                values?:
                                                  | Array<
                                                      string | null | undefined
                                                    >
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined
                                          >
                                        | null
                                        | undefined;
                                      variants?:
                                        | {
                                            __typename?: "VariantConnection";
                                            edges?:
                                              | Array<
                                                  | {
                                                      __typename?: "VariantEdge";
                                                      node?:
                                                        | {
                                                            __typename?: "ProductVariant";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            quantityAvailable?:
                                                              | number
                                                              | null
                                                              | undefined;
                                                            selectedOptions?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "ProductOption";
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                        | undefined;
                                                                      value?:
                                                                        | string
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                            price?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            compareAtPrice?:
                                                              | {
                                                                  __typename?: "Price";
                                                                  amount?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  currencyCode?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined
                                                >
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                    }
                                  | null
                                  | undefined;
                              }
                            | null
                            | undefined;
                        }
                      | null
                      | undefined;
                  }
                | null
                | undefined
              >;
            }
          | null
          | undefined;
      }
    | {
        __typename?: "SingleFeatureBlock";
        mediaType?: MediaType | null | undefined;
        title?: string | null | undefined;
        subtitle?: string | null | undefined;
        position: Position;
        alignment: Alignment;
        invert: boolean;
        animate: boolean;
        rectangleDivider: boolean;
        image: {
          __typename?: "FliteImage";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        imageSm: {
          __typename?: "FliteImage";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        video: {
          __typename?: "FliteVideo";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        videoSm: {
          __typename?: "FliteVideo";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        text?:
          | { __typename?: "Markdown"; md: string; html: string }
          | null
          | undefined;
        cta?:
          | {
              __typename?: "Link";
              href: string;
              text: string;
              bgColour?: string | null | undefined;
              textLight?: boolean | null | undefined;
            }
          | null
          | undefined;
        cta2?:
          | {
              __typename?: "Link";
              href: string;
              text: string;
              bgColour?: string | null | undefined;
              textLight?: boolean | null | undefined;
            }
          | null
          | undefined;
        blockCta?:
          | {
              __typename?: "Link";
              href: string;
              text: string;
              bgColour?: string | null | undefined;
              textLight?: boolean | null | undefined;
            }
          | null
          | undefined;
      }
    | {
        __typename?: "TextWithCtaBlock";
        title?: string | null | undefined;
        align: Position;
        rectangleDivider: boolean;
        text?:
          | { __typename?: "Markdown"; md: string; html: string }
          | null
          | undefined;
        link1?:
          | {
              __typename?: "Link";
              href: string;
              text: string;
              bgColour?: string | null | undefined;
              textLight?: boolean | null | undefined;
            }
          | null
          | undefined;
        link2?:
          | {
              __typename?: "Link";
              href: string;
              text: string;
              bgColour?: string | null | undefined;
              textLight?: boolean | null | undefined;
            }
          | null
          | undefined;
      }
    | {
        __typename?: "TwoImageHeroBlock";
        title?: string | null | undefined;
        title2?: string | null | undefined;
        invert: boolean;
        animate: boolean;
        cta?:
          | {
              __typename?: "Link";
              href: string;
              text: string;
              bgColour?: string | null | undefined;
            }
          | null
          | undefined;
        image: {
          __typename?: "FliteImage";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
        cta2?:
          | {
              __typename?: "Link";
              href: string;
              text: string;
              bgColour?: string | null | undefined;
            }
          | null
          | undefined;
        image2: {
          __typename?: "FliteImage";
          uri?: string | null | undefined;
          altText?: string | null | undefined;
        };
      }
    | null
    | undefined;
};

export type NavItemInfoFragment = {
  __typename?: "NavItem";
  id: string;
  title?: string | null | undefined;
  hidden?: boolean | null | undefined;
  highlighted?: boolean | null | undefined;
  href?: string | null | undefined;
  fullPath?: string | null | undefined;
  template?: string | null | undefined;
  promoimage?:
    | {
        __typename?: "PromoImage";
        image?:
          | {
              __typename?: "FliteImage";
              uri?: string | null | undefined;
              altText?: string | null | undefined;
            }
          | null
          | undefined;
        link?:
          | { __typename?: "Link"; href: string; text: string }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetNavItemByUrlQueryVariables = Exact<{
  url: Scalars["String"]["input"];
  appliedFilters?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  campaignId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetNavItemByUrlQuery = {
  __typename?: "Query";
  NavItemByURL?:
    | {
        __typename?: "NavItem";
        id: string;
        fullPath?: string | null | undefined;
        navTitle?: string | null | undefined;
        breadcrumbs?:
          | {
              __typename?: "BreadcrumbConnection";
              edges: Array<{
                __typename?: "NavItemEdge";
                node: {
                  __typename?: "NavItem";
                  id: string;
                  title?: string | null | undefined;
                  fullPath?: string | null | undefined;
                  items?:
                    | Array<
                        | {
                            __typename?: "NavItem";
                            id: string;
                            title?: string | null | undefined;
                            fullPath?: string | null | undefined;
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined;
                };
              }>;
            }
          | null
          | undefined;
        resource?:
          | {
              __typename: "Collection";
              id: string;
              title: string;
              tags: Array<string>;
              descriptionHtml?: string | null | undefined;
              handle: string;
              sortOrder?: CollectionSortOrder | null | undefined;
              totalProducts?: number | null | undefined;
              matchAnyTags: boolean;
              subNavLinks?:
                | Array<
                    | {
                        __typename?: "NavItem";
                        id: string;
                        title?: string | null | undefined;
                        fullPath?: string | null | undefined;
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined;
              seo: {
                __typename?: "SEO";
                title?: string | null | undefined;
                description?: string | null | undefined;
              };
              image?:
                | {
                    __typename?: "Image";
                    id?: string | null | undefined;
                    width?: number | null | undefined;
                    height?: number | null | undefined;
                    originalSrc: any;
                    altText?: string | null | undefined;
                  }
                | null
                | undefined;
              plpBlocks?:
                | Array<
                    | {
                        __typename?: "CampaignPromoBlock";
                        content?:
                          | {
                              __typename?: "ContentBlock";
                              id: string;
                              createDate?: any | null | undefined;
                              updateDate?: any | null | undefined;
                              contentType?: ContentType | null | undefined;
                              order?: number | null | undefined;
                              block?:
                                | {
                                    __typename?: "ArticleBlock";
                                    title?: string | null | undefined;
                                    subtitle?: string | null | undefined;
                                    invert: boolean;
                                    position: Position;
                                    alignment: Alignment;
                                    reverse: boolean;
                                    textPosition: Position;
                                    text?:
                                      | {
                                          __typename?: "Markdown";
                                          md: string;
                                          html: string;
                                        }
                                      | null
                                      | undefined;
                                    image: {
                                      __typename?: "FliteImage";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    cta?:
                                      | {
                                          __typename?: "Link";
                                          href: string;
                                          text: string;
                                          bgColour?: string | null | undefined;
                                          textLight?:
                                            | boolean
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | {
                                    __typename?: "Carousel";
                                    title?: string | null | undefined;
                                    size: CarouselSize;
                                    cta?:
                                      | {
                                          __typename?: "Link";
                                          href: string;
                                          text: string;
                                        }
                                      | null
                                      | undefined;
                                    collection?:
                                      | {
                                          __typename?: "Collection";
                                          url?: string | null | undefined;
                                        }
                                      | null
                                      | undefined;
                                    cards?:
                                      | {
                                          __typename?: "CardConnection";
                                          totalCount: number;
                                          edges: Array<
                                            | {
                                                __typename?: "CardEdge";
                                                node?:
                                                  | {
                                                      __typename?: "Card";
                                                      type?:
                                                        | CardType
                                                        | null
                                                        | undefined;
                                                      content?:
                                                        | {
                                                            __typename?: "DynamicGridCard";
                                                          }
                                                        | {
                                                            __typename?: "EditorialCard";
                                                            title?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            image?:
                                                              | {
                                                                  __typename?: "FliteImage";
                                                                  uri?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            cta?:
                                                              | {
                                                                  __typename?: "Link";
                                                                  href: string;
                                                                  text: string;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | {
                                                            __typename?: "ProductCard";
                                                            product?:
                                                              | {
                                                                  __typename?: "Product";
                                                                  id?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  title?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  subtitle?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  badge?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  handle?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  canonicalUrl?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  showPrice: boolean;
                                                                  tags?:
                                                                    | Array<
                                                                        | string
                                                                        | null
                                                                        | undefined
                                                                      >
                                                                    | null
                                                                    | undefined;
                                                                  image?:
                                                                    | {
                                                                        __typename?: "Image";
                                                                        id?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        altText?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        originalSrc: any;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  priceRange?:
                                                                    | {
                                                                        __typename?: "PriceRange";
                                                                        maxVariantPrice?:
                                                                          | {
                                                                              __typename?: "Price";
                                                                              amount?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                              currencyCode?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                            }
                                                                          | null
                                                                          | undefined;
                                                                        minVariantPrice?:
                                                                          | {
                                                                              __typename?: "Price";
                                                                              amount?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                              currencyCode?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                            }
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  compareAtPriceRange?:
                                                                    | {
                                                                        __typename?: "PriceRange";
                                                                        maxVariantPrice?:
                                                                          | {
                                                                              __typename?: "Price";
                                                                              amount?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                              currencyCode?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                            }
                                                                          | null
                                                                          | undefined;
                                                                        minVariantPrice?:
                                                                          | {
                                                                              __typename?: "Price";
                                                                              amount?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                              currencyCode?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                            }
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  options?:
                                                                    | Array<
                                                                        | {
                                                                            __typename?: "ProductOptions";
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                              | undefined;
                                                                            values?:
                                                                              | Array<
                                                                                  | string
                                                                                  | null
                                                                                  | undefined
                                                                                >
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined
                                                                      >
                                                                    | null
                                                                    | undefined;
                                                                  variants?:
                                                                    | {
                                                                        __typename?: "VariantConnection";
                                                                        edges?:
                                                                          | Array<
                                                                              | {
                                                                                  __typename?: "VariantEdge";
                                                                                  node?:
                                                                                    | {
                                                                                        __typename?: "ProductVariant";
                                                                                        id?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                        quantityAvailable?:
                                                                                          | number
                                                                                          | null
                                                                                          | undefined;
                                                                                        selectedOptions?:
                                                                                          | Array<
                                                                                              | {
                                                                                                  __typename?: "ProductOption";
                                                                                                  name?:
                                                                                                    | string
                                                                                                    | null
                                                                                                    | undefined;
                                                                                                  value?:
                                                                                                    | string
                                                                                                    | null
                                                                                                    | undefined;
                                                                                                }
                                                                                              | null
                                                                                              | undefined
                                                                                            >
                                                                                          | null
                                                                                          | undefined;
                                                                                        price?:
                                                                                          | {
                                                                                              __typename?: "Price";
                                                                                              amount?:
                                                                                                | string
                                                                                                | null
                                                                                                | undefined;
                                                                                              currencyCode?:
                                                                                                | string
                                                                                                | null
                                                                                                | undefined;
                                                                                            }
                                                                                          | null
                                                                                          | undefined;
                                                                                        compareAtPrice?:
                                                                                          | {
                                                                                              __typename?: "Price";
                                                                                              amount?:
                                                                                                | string
                                                                                                | null
                                                                                                | undefined;
                                                                                              currencyCode?:
                                                                                                | string
                                                                                                | null
                                                                                                | undefined;
                                                                                            }
                                                                                          | null
                                                                                          | undefined;
                                                                                      }
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined
                                                                            >
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined
                                          >;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | {
                                    __typename?: "DestinationFeature";
                                    mediaType?: MediaType | null | undefined;
                                    title?: string | null | undefined;
                                    subtitle?: string | null | undefined;
                                    invert: boolean;
                                    rectangleDivider: boolean;
                                    image: {
                                      __typename?: "FliteImage";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    imageSm: {
                                      __typename?: "FliteImage";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    video: {
                                      __typename?: "FliteVideo";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    videoSm: {
                                      __typename?: "FliteVideo";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    collection?:
                                      | {
                                          __typename?: "Collection";
                                          url?: string | null | undefined;
                                        }
                                      | null
                                      | undefined;
                                    text?:
                                      | {
                                          __typename?: "Markdown";
                                          md: string;
                                          html: string;
                                        }
                                      | null
                                      | undefined;
                                    cta?:
                                      | {
                                          __typename?: "Link";
                                          href: string;
                                          text: string;
                                          bgColour?: string | null | undefined;
                                          textLight?:
                                            | boolean
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                    cta2?:
                                      | {
                                          __typename?: "Link";
                                          href: string;
                                          text: string;
                                          bgColour?: string | null | undefined;
                                          textLight?:
                                            | boolean
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                    blockCta?:
                                      | {
                                          __typename?: "Link";
                                          href: string;
                                          text: string;
                                          bgColour?: string | null | undefined;
                                          textLight?:
                                            | boolean
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                    cards?:
                                      | {
                                          __typename?: "CardConnection";
                                          totalCount: number;
                                          edges: Array<
                                            | {
                                                __typename?: "CardEdge";
                                                node?:
                                                  | {
                                                      __typename?: "Card";
                                                      type?:
                                                        | CardType
                                                        | null
                                                        | undefined;
                                                      content?:
                                                        | {
                                                            __typename?: "DynamicGridCard";
                                                          }
                                                        | {
                                                            __typename?: "EditorialCard";
                                                            title?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            image?:
                                                              | {
                                                                  __typename?: "FliteImage";
                                                                  uri?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            cta?:
                                                              | {
                                                                  __typename?: "Link";
                                                                  href: string;
                                                                  text: string;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | {
                                                            __typename?: "ProductCard";
                                                            product?:
                                                              | {
                                                                  __typename?: "Product";
                                                                  id?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  title?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  subtitle?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  badge?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  handle?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  canonicalUrl?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  showPrice: boolean;
                                                                  tags?:
                                                                    | Array<
                                                                        | string
                                                                        | null
                                                                        | undefined
                                                                      >
                                                                    | null
                                                                    | undefined;
                                                                  image?:
                                                                    | {
                                                                        __typename?: "Image";
                                                                        id?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        altText?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        originalSrc: any;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  priceRange?:
                                                                    | {
                                                                        __typename?: "PriceRange";
                                                                        maxVariantPrice?:
                                                                          | {
                                                                              __typename?: "Price";
                                                                              amount?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                              currencyCode?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                            }
                                                                          | null
                                                                          | undefined;
                                                                        minVariantPrice?:
                                                                          | {
                                                                              __typename?: "Price";
                                                                              amount?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                              currencyCode?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                            }
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  compareAtPriceRange?:
                                                                    | {
                                                                        __typename?: "PriceRange";
                                                                        maxVariantPrice?:
                                                                          | {
                                                                              __typename?: "Price";
                                                                              amount?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                              currencyCode?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                            }
                                                                          | null
                                                                          | undefined;
                                                                        minVariantPrice?:
                                                                          | {
                                                                              __typename?: "Price";
                                                                              amount?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                              currencyCode?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                            }
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  options?:
                                                                    | Array<
                                                                        | {
                                                                            __typename?: "ProductOptions";
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                              | undefined;
                                                                            values?:
                                                                              | Array<
                                                                                  | string
                                                                                  | null
                                                                                  | undefined
                                                                                >
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined
                                                                      >
                                                                    | null
                                                                    | undefined;
                                                                  variants?:
                                                                    | {
                                                                        __typename?: "VariantConnection";
                                                                        edges?:
                                                                          | Array<
                                                                              | {
                                                                                  __typename?: "VariantEdge";
                                                                                  node?:
                                                                                    | {
                                                                                        __typename?: "ProductVariant";
                                                                                        id?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                        quantityAvailable?:
                                                                                          | number
                                                                                          | null
                                                                                          | undefined;
                                                                                        selectedOptions?:
                                                                                          | Array<
                                                                                              | {
                                                                                                  __typename?: "ProductOption";
                                                                                                  name?:
                                                                                                    | string
                                                                                                    | null
                                                                                                    | undefined;
                                                                                                  value?:
                                                                                                    | string
                                                                                                    | null
                                                                                                    | undefined;
                                                                                                }
                                                                                              | null
                                                                                              | undefined
                                                                                            >
                                                                                          | null
                                                                                          | undefined;
                                                                                        price?:
                                                                                          | {
                                                                                              __typename?: "Price";
                                                                                              amount?:
                                                                                                | string
                                                                                                | null
                                                                                                | undefined;
                                                                                              currencyCode?:
                                                                                                | string
                                                                                                | null
                                                                                                | undefined;
                                                                                            }
                                                                                          | null
                                                                                          | undefined;
                                                                                        compareAtPrice?:
                                                                                          | {
                                                                                              __typename?: "Price";
                                                                                              amount?:
                                                                                                | string
                                                                                                | null
                                                                                                | undefined;
                                                                                              currencyCode?:
                                                                                                | string
                                                                                                | null
                                                                                                | undefined;
                                                                                            }
                                                                                          | null
                                                                                          | undefined;
                                                                                      }
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined
                                                                            >
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined
                                          >;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | {
                                    __typename?: "DynamicGrid";
                                    autoscroll: boolean;
                                    speed: Speed;
                                    cards?:
                                      | {
                                          __typename?: "CardConnection";
                                          totalCount: number;
                                          edges: Array<
                                            | {
                                                __typename?: "CardEdge";
                                                node?:
                                                  | {
                                                      __typename?: "Card";
                                                      content?:
                                                        | {
                                                            __typename?: "DynamicGridCard";
                                                            content?:
                                                              | {
                                                                  __typename?: "DynamicGridCardContent";
                                                                  title?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  position: Position;
                                                                  alignment: Alignment;
                                                                  textAlignment?:
                                                                    | Position
                                                                    | null
                                                                    | undefined;
                                                                  invert: boolean;
                                                                  image: {
                                                                    __typename?: "FliteImage";
                                                                    uri?:
                                                                      | string
                                                                      | null
                                                                      | undefined;
                                                                    altText?:
                                                                      | string
                                                                      | null
                                                                      | undefined;
                                                                  };
                                                                  body?:
                                                                    | {
                                                                        __typename?: "Markdown";
                                                                        md: string;
                                                                        html: string;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  cta?:
                                                                    | {
                                                                        __typename?: "Link";
                                                                        href: string;
                                                                        text: string;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | {
                                                            __typename?: "EditorialCard";
                                                          }
                                                        | {
                                                            __typename?: "ProductCard";
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined
                                          >;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | {
                                    __typename?: "FilmBlock";
                                    title?: string | null | undefined;
                                    video: {
                                      __typename?: "FliteVideo";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    videoSm: {
                                      __typename?: "FliteVideo";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    coverImage: {
                                      __typename?: "FliteImage";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    coverImageSm: {
                                      __typename?: "FliteImage";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                  }
                                | { __typename?: "PromoBlock" }
                                | {
                                    __typename?: "QABlock";
                                    question1?: string | null | undefined;
                                    question2?: string | null | undefined;
                                    question3?: string | null | undefined;
                                    question4?: string | null | undefined;
                                    invert: boolean;
                                    position: Position;
                                    alignment: Alignment;
                                    reverse: boolean;
                                    textPosition: Position;
                                    answer1?:
                                      | {
                                          __typename?: "Markdown";
                                          md: string;
                                          html: string;
                                        }
                                      | null
                                      | undefined;
                                    answer2?:
                                      | {
                                          __typename?: "Markdown";
                                          md: string;
                                          html: string;
                                        }
                                      | null
                                      | undefined;
                                    answer3?:
                                      | {
                                          __typename?: "Markdown";
                                          md: string;
                                          html: string;
                                        }
                                      | null
                                      | undefined;
                                    answer4?:
                                      | {
                                          __typename?: "Markdown";
                                          md: string;
                                          html: string;
                                        }
                                      | null
                                      | undefined;
                                    image: {
                                      __typename?: "FliteImage";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    cta?:
                                      | {
                                          __typename?: "Link";
                                          href: string;
                                          text: string;
                                          bgColour?: string | null | undefined;
                                          textLight?:
                                            | boolean
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | {
                                    __typename?: "RecommendationBlock";
                                    title?: string | null | undefined;
                                    placementId?: string | null | undefined;
                                    size: CarouselSize;
                                    position: Position;
                                    cta?:
                                      | {
                                          __typename?: "Link";
                                          href: string;
                                          text: string;
                                          bgColour?: string | null | undefined;
                                          textLight?:
                                            | boolean
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | {
                                    __typename?: "ShopTheLook";
                                    mediaType?: MediaType | null | undefined;
                                    title?: string | null | undefined;
                                    invert: boolean;
                                    rectangleDivider: boolean;
                                    image: {
                                      __typename?: "FliteImage";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    imageSm: {
                                      __typename?: "FliteImage";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    text?:
                                      | {
                                          __typename?: "Markdown";
                                          md: string;
                                          html: string;
                                        }
                                      | null
                                      | undefined;
                                    cta?:
                                      | {
                                          __typename?: "Link";
                                          href: string;
                                          text: string;
                                          bgColour?: string | null | undefined;
                                          textLight?:
                                            | boolean
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                    cta2?:
                                      | {
                                          __typename?: "Link";
                                          href: string;
                                          text: string;
                                          bgColour?: string | null | undefined;
                                          textLight?:
                                            | boolean
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                    blockCta?:
                                      | {
                                          __typename?: "Link";
                                          href: string;
                                          text: string;
                                          bgColour?: string | null | undefined;
                                          textLight?:
                                            | boolean
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                    video: {
                                      __typename?: "FliteVideo";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    videoSm: {
                                      __typename?: "FliteVideo";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    collection?:
                                      | {
                                          __typename?: "Collection";
                                          url?: string | null | undefined;
                                        }
                                      | null
                                      | undefined;
                                    cards?:
                                      | {
                                          __typename?: "CardConnection";
                                          totalCount: number;
                                          edges: Array<
                                            | {
                                                __typename?: "CardEdge";
                                                node?:
                                                  | {
                                                      __typename?: "Card";
                                                      type?:
                                                        | CardType
                                                        | null
                                                        | undefined;
                                                      content?:
                                                        | {
                                                            __typename?: "DynamicGridCard";
                                                          }
                                                        | {
                                                            __typename?: "EditorialCard";
                                                            title?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            image?:
                                                              | {
                                                                  __typename?: "FliteImage";
                                                                  uri?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            cta?:
                                                              | {
                                                                  __typename?: "Link";
                                                                  href: string;
                                                                  text: string;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | {
                                                            __typename?: "ProductCard";
                                                            product?:
                                                              | {
                                                                  __typename?: "Product";
                                                                  id?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  title?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  subtitle?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  badge?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  handle?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  canonicalUrl?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  showPrice: boolean;
                                                                  tags?:
                                                                    | Array<
                                                                        | string
                                                                        | null
                                                                        | undefined
                                                                      >
                                                                    | null
                                                                    | undefined;
                                                                  image?:
                                                                    | {
                                                                        __typename?: "Image";
                                                                        id?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        altText?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        originalSrc: any;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  priceRange?:
                                                                    | {
                                                                        __typename?: "PriceRange";
                                                                        maxVariantPrice?:
                                                                          | {
                                                                              __typename?: "Price";
                                                                              amount?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                              currencyCode?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                            }
                                                                          | null
                                                                          | undefined;
                                                                        minVariantPrice?:
                                                                          | {
                                                                              __typename?: "Price";
                                                                              amount?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                              currencyCode?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                            }
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  compareAtPriceRange?:
                                                                    | {
                                                                        __typename?: "PriceRange";
                                                                        maxVariantPrice?:
                                                                          | {
                                                                              __typename?: "Price";
                                                                              amount?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                              currencyCode?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                            }
                                                                          | null
                                                                          | undefined;
                                                                        minVariantPrice?:
                                                                          | {
                                                                              __typename?: "Price";
                                                                              amount?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                              currencyCode?:
                                                                                | string
                                                                                | null
                                                                                | undefined;
                                                                            }
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  options?:
                                                                    | Array<
                                                                        | {
                                                                            __typename?: "ProductOptions";
                                                                            name?:
                                                                              | string
                                                                              | null
                                                                              | undefined;
                                                                            values?:
                                                                              | Array<
                                                                                  | string
                                                                                  | null
                                                                                  | undefined
                                                                                >
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined
                                                                      >
                                                                    | null
                                                                    | undefined;
                                                                  variants?:
                                                                    | {
                                                                        __typename?: "VariantConnection";
                                                                        edges?:
                                                                          | Array<
                                                                              | {
                                                                                  __typename?: "VariantEdge";
                                                                                  node?:
                                                                                    | {
                                                                                        __typename?: "ProductVariant";
                                                                                        id?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                        quantityAvailable?:
                                                                                          | number
                                                                                          | null
                                                                                          | undefined;
                                                                                        selectedOptions?:
                                                                                          | Array<
                                                                                              | {
                                                                                                  __typename?: "ProductOption";
                                                                                                  name?:
                                                                                                    | string
                                                                                                    | null
                                                                                                    | undefined;
                                                                                                  value?:
                                                                                                    | string
                                                                                                    | null
                                                                                                    | undefined;
                                                                                                }
                                                                                              | null
                                                                                              | undefined
                                                                                            >
                                                                                          | null
                                                                                          | undefined;
                                                                                        price?:
                                                                                          | {
                                                                                              __typename?: "Price";
                                                                                              amount?:
                                                                                                | string
                                                                                                | null
                                                                                                | undefined;
                                                                                              currencyCode?:
                                                                                                | string
                                                                                                | null
                                                                                                | undefined;
                                                                                            }
                                                                                          | null
                                                                                          | undefined;
                                                                                        compareAtPrice?:
                                                                                          | {
                                                                                              __typename?: "Price";
                                                                                              amount?:
                                                                                                | string
                                                                                                | null
                                                                                                | undefined;
                                                                                              currencyCode?:
                                                                                                | string
                                                                                                | null
                                                                                                | undefined;
                                                                                            }
                                                                                          | null
                                                                                          | undefined;
                                                                                      }
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined
                                                                            >
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined
                                          >;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | {
                                    __typename?: "SingleFeatureBlock";
                                    mediaType?: MediaType | null | undefined;
                                    title?: string | null | undefined;
                                    subtitle?: string | null | undefined;
                                    position: Position;
                                    alignment: Alignment;
                                    invert: boolean;
                                    animate: boolean;
                                    rectangleDivider: boolean;
                                    image: {
                                      __typename?: "FliteImage";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    imageSm: {
                                      __typename?: "FliteImage";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    video: {
                                      __typename?: "FliteVideo";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    videoSm: {
                                      __typename?: "FliteVideo";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    text?:
                                      | {
                                          __typename?: "Markdown";
                                          md: string;
                                          html: string;
                                        }
                                      | null
                                      | undefined;
                                    cta?:
                                      | {
                                          __typename?: "Link";
                                          href: string;
                                          text: string;
                                          bgColour?: string | null | undefined;
                                          textLight?:
                                            | boolean
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                    cta2?:
                                      | {
                                          __typename?: "Link";
                                          href: string;
                                          text: string;
                                          bgColour?: string | null | undefined;
                                          textLight?:
                                            | boolean
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                    blockCta?:
                                      | {
                                          __typename?: "Link";
                                          href: string;
                                          text: string;
                                          bgColour?: string | null | undefined;
                                          textLight?:
                                            | boolean
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | {
                                    __typename?: "TextWithCtaBlock";
                                    title?: string | null | undefined;
                                    align: Position;
                                    rectangleDivider: boolean;
                                    text?:
                                      | {
                                          __typename?: "Markdown";
                                          md: string;
                                          html: string;
                                        }
                                      | null
                                      | undefined;
                                    link1?:
                                      | {
                                          __typename?: "Link";
                                          href: string;
                                          text: string;
                                          bgColour?: string | null | undefined;
                                          textLight?:
                                            | boolean
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                    link2?:
                                      | {
                                          __typename?: "Link";
                                          href: string;
                                          text: string;
                                          bgColour?: string | null | undefined;
                                          textLight?:
                                            | boolean
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined;
                                  }
                                | {
                                    __typename?: "TwoImageHeroBlock";
                                    title?: string | null | undefined;
                                    title2?: string | null | undefined;
                                    invert: boolean;
                                    animate: boolean;
                                    cta?:
                                      | {
                                          __typename?: "Link";
                                          href: string;
                                          text: string;
                                          bgColour?: string | null | undefined;
                                        }
                                      | null
                                      | undefined;
                                    image: {
                                      __typename?: "FliteImage";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                    cta2?:
                                      | {
                                          __typename?: "Link";
                                          href: string;
                                          text: string;
                                          bgColour?: string | null | undefined;
                                        }
                                      | null
                                      | undefined;
                                    image2: {
                                      __typename?: "FliteImage";
                                      uri?: string | null | undefined;
                                      altText?: string | null | undefined;
                                    };
                                  }
                                | null
                                | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined;
              filterColors?:
                | {
                    __typename?: "FilterGroup";
                    type: FilterType;
                    label: string;
                    values: Array<{
                      __typename?: "FilterValue";
                      value: string;
                      rawTag: string;
                      count: number;
                    }>;
                  }
                | null
                | undefined;
              filterSizes?:
                | {
                    __typename?: "FilterGroup";
                    type: FilterType;
                    label: string;
                    values: Array<{
                      __typename?: "FilterValue";
                      value: string;
                      rawTag: string;
                      count: number;
                    }>;
                  }
                | null
                | undefined;
              filterMaterials?:
                | {
                    __typename?: "FilterGroup";
                    type: FilterType;
                    label: string;
                    values: Array<{
                      __typename?: "FilterValue";
                      value: string;
                      rawTag: string;
                      count: number;
                    }>;
                  }
                | null
                | undefined;
              filterCategory?:
                | {
                    __typename?: "FilterGroup";
                    type: FilterType;
                    label: string;
                    values: Array<{
                      __typename?: "FilterValue";
                      value: string;
                      rawTag: string;
                      count: number;
                    }>;
                  }
                | null
                | undefined;
            }
          | {
              __typename: "Page";
              id: string;
              meta?:
                | {
                    __typename?: "Meta";
                    title?: string | null | undefined;
                    description?: string | null | undefined;
                    keywords?:
                      | Array<string | null | undefined>
                      | null
                      | undefined;
                  }
                | null
                | undefined;
              contents?:
                | Array<
                    | {
                        __typename?: "ContentBlock";
                        id: string;
                        createDate?: any | null | undefined;
                        updateDate?: any | null | undefined;
                        contentType?: ContentType | null | undefined;
                        order?: number | null | undefined;
                        block?:
                          | {
                              __typename?: "ArticleBlock";
                              title?: string | null | undefined;
                              subtitle?: string | null | undefined;
                              invert: boolean;
                              position: Position;
                              alignment: Alignment;
                              reverse: boolean;
                              textPosition: Position;
                              text?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              image: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              cta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "Carousel";
                              title?: string | null | undefined;
                              size: CarouselSize;
                              cta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                  }
                                | null
                                | undefined;
                              collection?:
                                | {
                                    __typename?: "Collection";
                                    url?: string | null | undefined;
                                  }
                                | null
                                | undefined;
                              cards?:
                                | {
                                    __typename?: "CardConnection";
                                    totalCount: number;
                                    edges: Array<
                                      | {
                                          __typename?: "CardEdge";
                                          node?:
                                            | {
                                                __typename?: "Card";
                                                type?:
                                                  | CardType
                                                  | null
                                                  | undefined;
                                                content?:
                                                  | {
                                                      __typename?: "DynamicGridCard";
                                                    }
                                                  | {
                                                      __typename?: "EditorialCard";
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      image?:
                                                        | {
                                                            __typename?: "FliteImage";
                                                            uri?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            altText?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      cta?:
                                                        | {
                                                            __typename?: "Link";
                                                            href: string;
                                                            text: string;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | {
                                                      __typename?: "ProductCard";
                                                      product?:
                                                        | {
                                                            __typename?: "Product";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            title?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            subtitle?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            badge?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            handle?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            canonicalUrl?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            showPrice: boolean;
                                                            tags?:
                                                              | Array<
                                                                  | string
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                            image?:
                                                              | {
                                                                  __typename?: "Image";
                                                                  id?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  originalSrc: any;
                                                                }
                                                              | null
                                                              | undefined;
                                                            priceRange?:
                                                              | {
                                                                  __typename?: "PriceRange";
                                                                  maxVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  minVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            compareAtPriceRange?:
                                                              | {
                                                                  __typename?: "PriceRange";
                                                                  maxVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  minVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            options?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "ProductOptions";
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                        | undefined;
                                                                      values?:
                                                                        | Array<
                                                                            | string
                                                                            | null
                                                                            | undefined
                                                                          >
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                            variants?:
                                                              | {
                                                                  __typename?: "VariantConnection";
                                                                  edges?:
                                                                    | Array<
                                                                        | {
                                                                            __typename?: "VariantEdge";
                                                                            node?:
                                                                              | {
                                                                                  __typename?: "ProductVariant";
                                                                                  id?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  quantityAvailable?:
                                                                                    | number
                                                                                    | null
                                                                                    | undefined;
                                                                                  selectedOptions?:
                                                                                    | Array<
                                                                                        | {
                                                                                            __typename?: "ProductOption";
                                                                                            name?:
                                                                                              | string
                                                                                              | null
                                                                                              | undefined;
                                                                                            value?:
                                                                                              | string
                                                                                              | null
                                                                                              | undefined;
                                                                                          }
                                                                                        | null
                                                                                        | undefined
                                                                                      >
                                                                                    | null
                                                                                    | undefined;
                                                                                  price?:
                                                                                    | {
                                                                                        __typename?: "Price";
                                                                                        amount?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                        currencyCode?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                      }
                                                                                    | null
                                                                                    | undefined;
                                                                                  compareAtPrice?:
                                                                                    | {
                                                                                        __typename?: "Price";
                                                                                        amount?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                        currencyCode?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                      }
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined
                                                                      >
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined
                                    >;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "DestinationFeature";
                              mediaType?: MediaType | null | undefined;
                              title?: string | null | undefined;
                              subtitle?: string | null | undefined;
                              invert: boolean;
                              rectangleDivider: boolean;
                              image: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              imageSm: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              video: {
                                __typename?: "FliteVideo";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              videoSm: {
                                __typename?: "FliteVideo";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              collection?:
                                | {
                                    __typename?: "Collection";
                                    url?: string | null | undefined;
                                  }
                                | null
                                | undefined;
                              text?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              cta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              cta2?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              blockCta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              cards?:
                                | {
                                    __typename?: "CardConnection";
                                    totalCount: number;
                                    edges: Array<
                                      | {
                                          __typename?: "CardEdge";
                                          node?:
                                            | {
                                                __typename?: "Card";
                                                type?:
                                                  | CardType
                                                  | null
                                                  | undefined;
                                                content?:
                                                  | {
                                                      __typename?: "DynamicGridCard";
                                                    }
                                                  | {
                                                      __typename?: "EditorialCard";
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      image?:
                                                        | {
                                                            __typename?: "FliteImage";
                                                            uri?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            altText?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      cta?:
                                                        | {
                                                            __typename?: "Link";
                                                            href: string;
                                                            text: string;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | {
                                                      __typename?: "ProductCard";
                                                      product?:
                                                        | {
                                                            __typename?: "Product";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            title?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            subtitle?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            badge?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            handle?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            canonicalUrl?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            showPrice: boolean;
                                                            tags?:
                                                              | Array<
                                                                  | string
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                            image?:
                                                              | {
                                                                  __typename?: "Image";
                                                                  id?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  originalSrc: any;
                                                                }
                                                              | null
                                                              | undefined;
                                                            priceRange?:
                                                              | {
                                                                  __typename?: "PriceRange";
                                                                  maxVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  minVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            compareAtPriceRange?:
                                                              | {
                                                                  __typename?: "PriceRange";
                                                                  maxVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  minVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            options?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "ProductOptions";
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                        | undefined;
                                                                      values?:
                                                                        | Array<
                                                                            | string
                                                                            | null
                                                                            | undefined
                                                                          >
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                            variants?:
                                                              | {
                                                                  __typename?: "VariantConnection";
                                                                  edges?:
                                                                    | Array<
                                                                        | {
                                                                            __typename?: "VariantEdge";
                                                                            node?:
                                                                              | {
                                                                                  __typename?: "ProductVariant";
                                                                                  id?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  quantityAvailable?:
                                                                                    | number
                                                                                    | null
                                                                                    | undefined;
                                                                                  selectedOptions?:
                                                                                    | Array<
                                                                                        | {
                                                                                            __typename?: "ProductOption";
                                                                                            name?:
                                                                                              | string
                                                                                              | null
                                                                                              | undefined;
                                                                                            value?:
                                                                                              | string
                                                                                              | null
                                                                                              | undefined;
                                                                                          }
                                                                                        | null
                                                                                        | undefined
                                                                                      >
                                                                                    | null
                                                                                    | undefined;
                                                                                  price?:
                                                                                    | {
                                                                                        __typename?: "Price";
                                                                                        amount?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                        currencyCode?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                      }
                                                                                    | null
                                                                                    | undefined;
                                                                                  compareAtPrice?:
                                                                                    | {
                                                                                        __typename?: "Price";
                                                                                        amount?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                        currencyCode?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                      }
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined
                                                                      >
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined
                                    >;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "DynamicGrid";
                              autoscroll: boolean;
                              speed: Speed;
                              cards?:
                                | {
                                    __typename?: "CardConnection";
                                    totalCount: number;
                                    edges: Array<
                                      | {
                                          __typename?: "CardEdge";
                                          node?:
                                            | {
                                                __typename?: "Card";
                                                content?:
                                                  | {
                                                      __typename?: "DynamicGridCard";
                                                      content?:
                                                        | {
                                                            __typename?: "DynamicGridCardContent";
                                                            title?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            position: Position;
                                                            alignment: Alignment;
                                                            textAlignment?:
                                                              | Position
                                                              | null
                                                              | undefined;
                                                            invert: boolean;
                                                            image: {
                                                              __typename?: "FliteImage";
                                                              uri?:
                                                                | string
                                                                | null
                                                                | undefined;
                                                              altText?:
                                                                | string
                                                                | null
                                                                | undefined;
                                                            };
                                                            body?:
                                                              | {
                                                                  __typename?: "Markdown";
                                                                  md: string;
                                                                  html: string;
                                                                }
                                                              | null
                                                              | undefined;
                                                            cta?:
                                                              | {
                                                                  __typename?: "Link";
                                                                  href: string;
                                                                  text: string;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | {
                                                      __typename?: "EditorialCard";
                                                    }
                                                  | {
                                                      __typename?: "ProductCard";
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined
                                    >;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "FilmBlock";
                              title?: string | null | undefined;
                              video: {
                                __typename?: "FliteVideo";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              videoSm: {
                                __typename?: "FliteVideo";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              coverImage: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              coverImageSm: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                            }
                          | { __typename?: "PromoBlock" }
                          | {
                              __typename?: "QABlock";
                              question1?: string | null | undefined;
                              question2?: string | null | undefined;
                              question3?: string | null | undefined;
                              question4?: string | null | undefined;
                              invert: boolean;
                              position: Position;
                              alignment: Alignment;
                              reverse: boolean;
                              textPosition: Position;
                              answer1?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              answer2?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              answer3?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              answer4?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              image: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              cta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "RecommendationBlock";
                              title?: string | null | undefined;
                              placementId?: string | null | undefined;
                              size: CarouselSize;
                              position: Position;
                              cta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "ShopTheLook";
                              mediaType?: MediaType | null | undefined;
                              title?: string | null | undefined;
                              invert: boolean;
                              rectangleDivider: boolean;
                              image: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              imageSm: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              text?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              cta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              cta2?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              blockCta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              video: {
                                __typename?: "FliteVideo";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              videoSm: {
                                __typename?: "FliteVideo";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              collection?:
                                | {
                                    __typename?: "Collection";
                                    url?: string | null | undefined;
                                  }
                                | null
                                | undefined;
                              cards?:
                                | {
                                    __typename?: "CardConnection";
                                    totalCount: number;
                                    edges: Array<
                                      | {
                                          __typename?: "CardEdge";
                                          node?:
                                            | {
                                                __typename?: "Card";
                                                type?:
                                                  | CardType
                                                  | null
                                                  | undefined;
                                                content?:
                                                  | {
                                                      __typename?: "DynamicGridCard";
                                                    }
                                                  | {
                                                      __typename?: "EditorialCard";
                                                      title?:
                                                        | string
                                                        | null
                                                        | undefined;
                                                      image?:
                                                        | {
                                                            __typename?: "FliteImage";
                                                            uri?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            altText?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                      cta?:
                                                        | {
                                                            __typename?: "Link";
                                                            href: string;
                                                            text: string;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | {
                                                      __typename?: "ProductCard";
                                                      product?:
                                                        | {
                                                            __typename?: "Product";
                                                            id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            title?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            subtitle?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            badge?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            handle?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            canonicalUrl?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                            showPrice: boolean;
                                                            tags?:
                                                              | Array<
                                                                  | string
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                            image?:
                                                              | {
                                                                  __typename?: "Image";
                                                                  id?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  altText?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                                  originalSrc: any;
                                                                }
                                                              | null
                                                              | undefined;
                                                            priceRange?:
                                                              | {
                                                                  __typename?: "PriceRange";
                                                                  maxVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  minVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            compareAtPriceRange?:
                                                              | {
                                                                  __typename?: "PriceRange";
                                                                  maxVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                  minVariantPrice?:
                                                                    | {
                                                                        __typename?: "Price";
                                                                        amount?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                        currencyCode?:
                                                                          | string
                                                                          | null
                                                                          | undefined;
                                                                      }
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                            options?:
                                                              | Array<
                                                                  | {
                                                                      __typename?: "ProductOptions";
                                                                      name?:
                                                                        | string
                                                                        | null
                                                                        | undefined;
                                                                      values?:
                                                                        | Array<
                                                                            | string
                                                                            | null
                                                                            | undefined
                                                                          >
                                                                        | null
                                                                        | undefined;
                                                                    }
                                                                  | null
                                                                  | undefined
                                                                >
                                                              | null
                                                              | undefined;
                                                            variants?:
                                                              | {
                                                                  __typename?: "VariantConnection";
                                                                  edges?:
                                                                    | Array<
                                                                        | {
                                                                            __typename?: "VariantEdge";
                                                                            node?:
                                                                              | {
                                                                                  __typename?: "ProductVariant";
                                                                                  id?:
                                                                                    | string
                                                                                    | null
                                                                                    | undefined;
                                                                                  quantityAvailable?:
                                                                                    | number
                                                                                    | null
                                                                                    | undefined;
                                                                                  selectedOptions?:
                                                                                    | Array<
                                                                                        | {
                                                                                            __typename?: "ProductOption";
                                                                                            name?:
                                                                                              | string
                                                                                              | null
                                                                                              | undefined;
                                                                                            value?:
                                                                                              | string
                                                                                              | null
                                                                                              | undefined;
                                                                                          }
                                                                                        | null
                                                                                        | undefined
                                                                                      >
                                                                                    | null
                                                                                    | undefined;
                                                                                  price?:
                                                                                    | {
                                                                                        __typename?: "Price";
                                                                                        amount?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                        currencyCode?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                      }
                                                                                    | null
                                                                                    | undefined;
                                                                                  compareAtPrice?:
                                                                                    | {
                                                                                        __typename?: "Price";
                                                                                        amount?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                        currencyCode?:
                                                                                          | string
                                                                                          | null
                                                                                          | undefined;
                                                                                      }
                                                                                    | null
                                                                                    | undefined;
                                                                                }
                                                                              | null
                                                                              | undefined;
                                                                          }
                                                                        | null
                                                                        | undefined
                                                                      >
                                                                    | null
                                                                    | undefined;
                                                                }
                                                              | null
                                                              | undefined;
                                                          }
                                                        | null
                                                        | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                              }
                                            | null
                                            | undefined;
                                        }
                                      | null
                                      | undefined
                                    >;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "SingleFeatureBlock";
                              mediaType?: MediaType | null | undefined;
                              title?: string | null | undefined;
                              subtitle?: string | null | undefined;
                              position: Position;
                              alignment: Alignment;
                              invert: boolean;
                              animate: boolean;
                              rectangleDivider: boolean;
                              image: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              imageSm: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              video: {
                                __typename?: "FliteVideo";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              videoSm: {
                                __typename?: "FliteVideo";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              text?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              cta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              cta2?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              blockCta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "TextWithCtaBlock";
                              title?: string | null | undefined;
                              align: Position;
                              rectangleDivider: boolean;
                              text?:
                                | {
                                    __typename?: "Markdown";
                                    md: string;
                                    html: string;
                                  }
                                | null
                                | undefined;
                              link1?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                              link2?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                    textLight?: boolean | null | undefined;
                                  }
                                | null
                                | undefined;
                            }
                          | {
                              __typename?: "TwoImageHeroBlock";
                              title?: string | null | undefined;
                              title2?: string | null | undefined;
                              invert: boolean;
                              animate: boolean;
                              cta?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                  }
                                | null
                                | undefined;
                              image: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                              cta2?:
                                | {
                                    __typename?: "Link";
                                    href: string;
                                    text: string;
                                    bgColour?: string | null | undefined;
                                  }
                                | null
                                | undefined;
                              image2: {
                                __typename?: "FliteImage";
                                uri?: string | null | undefined;
                                altText?: string | null | undefined;
                              };
                            }
                          | null
                          | undefined;
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetBreadcrumbsByUrlQueryVariables = Exact<{
  url: Scalars["String"]["input"];
}>;

export type GetBreadcrumbsByUrlQuery = {
  __typename?: "Query";
  NavItemByURL?:
    | {
        __typename?: "NavItem";
        id: string;
        title?: string | null | undefined;
        fullPath?: string | null | undefined;
        breadcrumbs?:
          | {
              __typename?: "BreadcrumbConnection";
              edges: Array<{
                __typename?: "NavItemEdge";
                node: {
                  __typename?: "NavItem";
                  title?: string | null | undefined;
                  fullPath?: string | null | undefined;
                };
              }>;
            }
          | null
          | undefined;
        resource?:
          | { __typename?: "Collection"; id: string }
          | { __typename?: "Page"; id: string }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type ValidateTokenQueryVariables = Exact<{ [key: string]: never }>;

export type ValidateTokenQuery = {
  __typename?: "Query";
  CheckPreviewToken?:
    | { __typename?: "TokenCheck"; valid: boolean }
    | null
    | undefined;
};

export const FiltersFragmentFragmentDoc = gql`
  fragment FiltersFragment on Collection {
    totalProducts(appliedFilters: $appliedFilters)
    filterColors: filters(forType: COLOR, appliedFilters: $appliedFilters) {
      type
      label
      values {
        value
        rawTag
        count
      }
    }
    filterSizes: filters(forType: SIZE, appliedFilters: $appliedFilters) {
      type
      label
      values {
        value
        rawTag
        count
      }
    }
    filterMaterials: filters(
      forType: MATERIAL
      appliedFilters: $appliedFilters
    ) {
      type
      label
      values {
        value
        rawTag
        count
      }
    }
    filterCategory: filters(
      forType: CATEGORY
      appliedFilters: $appliedFilters
    ) {
      type
      label
      values {
        value
        rawTag
        count
      }
    }
  }
`;
export const CoreCollectionFieldsFragmentDoc = gql`
  fragment CoreCollectionFields on Collection {
    id
    title
    tags
    descriptionHtml
    handle
    sortOrder
    seo {
      title
      description
    }
    totalProducts(appliedFilters: $appliedFilters)
    matchAnyTags
    image {
      id
      width
      height
      originalSrc
      altText
    }
  }
`;
export const SingleFeatureFragmentFragmentDoc = gql`
  fragment SingleFeatureFragment on SingleFeatureBlock {
    mediaType
    image {
      uri
      altText
    }
    imageSm {
      uri
      altText
    }
    video {
      uri
      altText
    }
    videoSm {
      uri
      altText
    }
    title
    subtitle
    text {
      md
      html
    }
    cta {
      href
      text
      bgColour
      textLight
    }
    cta2 {
      href
      text
      bgColour
      textLight
    }
    blockCta {
      href
      text
      bgColour
      textLight
    }
    position
    alignment
    invert
    animate
    rectangleDivider
  }
`;
export const CardsFragmentFragmentDoc = gql`
  fragment CardsFragment on CardConnection {
    totalCount
    edges {
      node {
        type
        content {
          ... on ProductCard {
            product {
              id
              title
              subtitle
              badge
              handle
              canonicalUrl
              showPrice
              image {
                id
                altText
                originalSrc
              }
              priceRange {
                maxVariantPrice {
                  amount
                  currencyCode
                }
                minVariantPrice {
                  amount
                  currencyCode
                }
              }
              compareAtPriceRange {
                maxVariantPrice {
                  amount
                  currencyCode
                }
                minVariantPrice {
                  amount
                  currencyCode
                }
              }
              tags
              options {
                name
                values
              }
              variants {
                edges {
                  node {
                    id
                    quantityAvailable
                    selectedOptions {
                      name
                      value
                    }
                    price {
                      amount
                      currencyCode
                    }
                    compareAtPrice {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
          }
          ... on EditorialCard {
            title
            image {
              uri
              altText
            }
            cta {
              href
              text
            }
          }
        }
      }
    }
  }
`;
export const CarouselFragmentFragmentDoc = gql`
  fragment CarouselFragment on Carousel {
    title
    size
    cta {
      href
      text
    }
    collection {
      url
    }
    cards(limit: $limit) {
      ...CardsFragment
    }
  }
  ${CardsFragmentFragmentDoc}
`;
export const TextWithCtaFragmentFragmentDoc = gql`
  fragment TextWithCtaFragment on TextWithCtaBlock {
    title
    text {
      md
      html
    }
    link1 {
      href
      text
      bgColour
      textLight
    }
    link2 {
      href
      text
      bgColour
      textLight
    }
    align
    rectangleDivider
  }
`;
export const TwoImageHeroFragmentFragmentDoc = gql`
  fragment TwoImageHeroFragment on TwoImageHeroBlock {
    title
    cta {
      href
      text
      bgColour
    }
    image {
      uri
      altText
    }
    title2
    cta2 {
      href
      text
      bgColour
    }
    image2 {
      uri
      altText
    }
    invert
    animate
  }
`;
export const FilmFragmentFragmentDoc = gql`
  fragment FilmFragment on FilmBlock {
    title
    video {
      uri
      altText
    }
    videoSm {
      uri
      altText
    }
    coverImage {
      uri
      altText
    }
    coverImageSm {
      uri
      altText
    }
  }
`;
export const ShopTheLookFragmentFragmentDoc = gql`
  fragment ShopTheLookFragment on ShopTheLook {
    mediaType
    image {
      uri
      altText
    }
    imageSm {
      uri
      altText
    }
    title
    text {
      md
      html
    }
    cta {
      href
      text
      bgColour
      textLight
    }
    cta2 {
      href
      text
      bgColour
      textLight
    }
    blockCta {
      href
      text
      bgColour
      textLight
    }
    invert
    rectangleDivider
    mediaType
    video {
      uri
      altText
    }
    videoSm {
      uri
      altText
    }
    collection {
      url
    }
    cards(limit: $limit) {
      ...CardsFragment
    }
  }
  ${CardsFragmentFragmentDoc}
`;
export const DestinationFeatureFragmentFragmentDoc = gql`
  fragment DestinationFeatureFragment on DestinationFeature {
    mediaType
    image {
      uri
      altText
    }
    imageSm {
      uri
      altText
    }
    video {
      uri
      altText
    }
    videoSm {
      uri
      altText
    }
    collection {
      url
    }
    title
    subtitle
    text {
      md
      html
    }
    cta {
      href
      text
      bgColour
      textLight
    }
    cta2 {
      href
      text
      bgColour
      textLight
    }
    blockCta {
      href
      text
      bgColour
      textLight
    }
    invert
    rectangleDivider
    cards {
      ...CardsFragment
    }
  }
  ${CardsFragmentFragmentDoc}
`;
export const ArticleFragmentFragmentDoc = gql`
  fragment ArticleFragment on ArticleBlock {
    title
    subtitle
    text {
      md
      html
    }
    image {
      uri
      altText
    }
    cta {
      href
      text
      bgColour
      textLight
    }
    invert
    position
    alignment
    reverse
    textPosition
  }
`;
export const QaFragmentFragmentDoc = gql`
  fragment QAFragment on QABlock {
    question1
    answer1 {
      md
      html
    }
    question2
    answer2 {
      md
      html
    }
    question3
    answer3 {
      md
      html
    }
    question4
    answer4 {
      md
      html
    }
    image {
      uri
      altText
    }
    cta {
      href
      text
      bgColour
      textLight
    }
    invert
    position
    alignment
    reverse
    textPosition
  }
`;
export const DynamicGridFragmentFragmentDoc = gql`
  fragment DynamicGridFragment on DynamicGrid {
    cards(limit: $limit) {
      totalCount
      edges {
        node {
          content {
            ... on DynamicGridCard {
              content {
                image {
                  uri
                  altText
                }
                title
                body {
                  md
                  html
                }
                cta {
                  href
                  text
                }
                position
                alignment
                textAlignment
                invert
              }
            }
          }
        }
      }
    }
    autoscroll
    speed
  }
`;
export const RecommendationFragmentFragmentDoc = gql`
  fragment RecommendationFragment on RecommendationBlock {
    title
    cta {
      href
      text
      bgColour
      textLight
    }
    placementId
    size
    position
  }
`;
export const ContentBlocksFragmentDoc = gql`
  fragment ContentBlocks on ContentBlock {
    id
    createDate
    updateDate
    contentType
    order
    block {
      ... on SingleFeatureBlock {
        ...SingleFeatureFragment
      }
      ... on Carousel {
        ...CarouselFragment
      }
      ... on TextWithCtaBlock {
        ...TextWithCtaFragment
      }
      ... on TwoImageHeroBlock {
        ...TwoImageHeroFragment
      }
      ... on FilmBlock {
        ...FilmFragment
      }
      ... on ShopTheLook {
        ...ShopTheLookFragment
      }
      ... on DestinationFeature {
        ...DestinationFeatureFragment
      }
      ... on ArticleBlock {
        ...ArticleFragment
      }
      ... on QABlock {
        ...QAFragment
      }
      ... on DynamicGrid {
        ...DynamicGridFragment
      }
      ... on RecommendationBlock {
        ...RecommendationFragment
      }
    }
  }
  ${SingleFeatureFragmentFragmentDoc}
  ${CarouselFragmentFragmentDoc}
  ${TextWithCtaFragmentFragmentDoc}
  ${TwoImageHeroFragmentFragmentDoc}
  ${FilmFragmentFragmentDoc}
  ${ShopTheLookFragmentFragmentDoc}
  ${DestinationFeatureFragmentFragmentDoc}
  ${ArticleFragmentFragmentDoc}
  ${QaFragmentFragmentDoc}
  ${DynamicGridFragmentFragmentDoc}
  ${RecommendationFragmentFragmentDoc}
`;
export const CollectionBlocksFragmentDoc = gql`
  fragment CollectionBlocks on Collection {
    plpBlocks: promoBlocks(template: "plp", campaignId: $campaignId) {
      content {
        ...ContentBlocks
      }
    }
  }
  ${ContentBlocksFragmentDoc}
`;
export const NavItemInfoFragmentDoc = gql`
  fragment navItemInfo on NavItem {
    id
    title
    hidden
    highlighted
    href
    fullPath
    template
    promoimage {
      image {
        uri
        altText
      }
      link {
        href
        text
      }
    }
  }
`;
export const GetCmsCollectionDoc = gql`
  query GetCmsCollection($colId: ID!, $appliedFilters: [String]) {
    Collection(id: $colId) {
      id
      ...FiltersFragment
    }
  }
  ${FiltersFragmentFragmentDoc}
`;
export const UpdateFiltersDoc = gql`
  query UpdateFilters($colId: ID!, $appliedFilters: [String]) {
    Collection(id: $colId) {
      id
      ...FiltersFragment
    }
  }
  ${FiltersFragmentFragmentDoc}
`;
export const MarketingSignupDoc = gql`
  mutation MarketingSignup(
    $email: String!
    $gender: String!
    $locale: String!
    $honeypot: String
  ) {
    AddMarketingEmail(
      email: $email
      gender: $gender
      locale: $locale
      honeypot: $honeypot
    )
  }
`;
export const GetCustomerMarketingDoc = gql`
  query GetCustomerMarketing($token: String!) {
    CustomerGetMarketing(customerAccessToken: $token) {
      id
      acceptsMarketing
      locale
      gender
    }
  }
`;
export const SetMarketingDoc = gql`
  mutation SetMarketing(
    $token: String!
    $input: CustomerUpdateMarketingInput!
  ) {
    CustomerUpdateMarketing(customerAccessToken: $token, input: $input) {
      id
      acceptsMarketing
      locale
      gender
    }
  }
`;
export const BannersDoc = gql`
  query Banners {
    ListBanners(first: 3) {
      edges {
        node {
          id
          icon
          text {
            html
            md
          }
          link1 {
            text
            href
          }
          link2 {
            text
            href
          }
          createDate
          updateDate
          publishFrom
          bgColour
          textLight
        }
      }
    }
  }
`;
export const GetPageDoc = gql`
  query GetPage($pageId: ID!, $revisionId: ID, $limit: Int) {
    Page(id: $pageId, revisionId: $revisionId) {
      id
      meta {
        title
        description
        keywords
      }
      theme
      contents {
        ...ContentBlocks
      }
    }
  }
  ${ContentBlocksFragmentDoc}
`;
export const GetNavDoc = gql`
  query GetNav($id: ID!, $revisionId: ID) {
    Nav(id: $id, revisionId: $revisionId) {
      id
      store
      handle
      items {
        ...navItemInfo
        items {
          ...navItemInfo
          items {
            ...navItemInfo
          }
        }
      }
    }
  }
  ${NavItemInfoFragmentDoc}
`;
export const GetResourceByUrlDoc = gql`
  query GetResourceByURL(
    $url: String!
    $appliedFilters: [String]
    $limit: Int
    $campaignId: ID
  ) {
    ResourceByURL(url: $url) {
      __typename
      ... on Page {
        id
        meta {
          title
          description
          keywords
        }
        theme
        contents {
          ...ContentBlocks
        }
      }
      ... on Collection {
        ...CoreCollectionFields
        ...CollectionBlocks
      }
    }
  }
  ${ContentBlocksFragmentDoc}
  ${CoreCollectionFieldsFragmentDoc}
  ${CollectionBlocksFragmentDoc}
`;
export const GetNavItemByUrlDoc = gql`
  query GetNavItemByURL(
    $url: String!
    $appliedFilters: [String]
    $limit: Int
    $campaignId: ID
  ) {
    NavItemByURL(url: $url) {
      id
      navTitle: title
      fullPath
      breadcrumbs {
        edges {
          node {
            id
            title
            fullPath
            items {
              id
              title
              fullPath
            }
          }
        }
      }
      resource {
        __typename
        ... on Page {
          id
          meta {
            title
            description
            keywords
          }
          contents {
            ...ContentBlocks
          }
        }
        ... on Collection {
          ...CoreCollectionFields
          ...CollectionBlocks
          ...FiltersFragment
          subNavLinks {
            id
            title
            fullPath
          }
        }
      }
    }
  }
  ${ContentBlocksFragmentDoc}
  ${CoreCollectionFieldsFragmentDoc}
  ${CollectionBlocksFragmentDoc}
  ${FiltersFragmentFragmentDoc}
`;
export const GetBreadcrumbsByUrlDoc = gql`
  query GetBreadcrumbsByURL($url: String!) {
    NavItemByURL(url: $url) {
      id
      title
      fullPath
      breadcrumbs {
        edges {
          node {
            title
            fullPath
          }
        }
      }
      resource {
        ... on Collection {
          id
        }
        ... on Page {
          id
        }
      }
    }
  }
`;
export const ValidateTokenDoc = gql`
  query ValidateToken {
    CheckPreviewToken {
      valid
    }
  }
`;
export const GetCmsCollection = (
  options: Omit<WatchQueryOptions<GetCmsCollectionQueryVariables>, "query">,
): Readable<
  ApolloQueryResult<GetCmsCollectionQuery> & {
    query: ObservableQuery<
      GetCmsCollectionQuery,
      GetCmsCollectionQueryVariables
    >;
  }
> => {
  const q = client.watchQuery({
    query: GetCmsCollectionDoc,
    ...options,
  });
  var result = readable<
    ApolloQueryResult<GetCmsCollectionQuery> & {
      query: ObservableQuery<
        GetCmsCollectionQuery,
        GetCmsCollectionQueryVariables
      >;
    }
  >(
    {
      data: {} as any,
      loading: true,
      error: undefined,
      networkStatus: 1,
      query: q,
    },
    set => {
      q.subscribe((v: any) => {
        set({ ...v, query: q });
      });
    },
  );
  return result;
};

export const UpdateFilters = (
  options: Omit<WatchQueryOptions<UpdateFiltersQueryVariables>, "query">,
): Readable<
  ApolloQueryResult<UpdateFiltersQuery> & {
    query: ObservableQuery<UpdateFiltersQuery, UpdateFiltersQueryVariables>;
  }
> => {
  const q = client.watchQuery({
    query: UpdateFiltersDoc,
    ...options,
  });
  var result = readable<
    ApolloQueryResult<UpdateFiltersQuery> & {
      query: ObservableQuery<UpdateFiltersQuery, UpdateFiltersQueryVariables>;
    }
  >(
    {
      data: {} as any,
      loading: true,
      error: undefined,
      networkStatus: 1,
      query: q,
    },
    set => {
      q.subscribe((v: any) => {
        set({ ...v, query: q });
      });
    },
  );
  return result;
};

export const MarketingSignup = (
  options: Omit<
    MutationOptions<any, MarketingSignupMutationVariables>,
    "mutation"
  >,
) => {
  const m = client.mutate<
    MarketingSignupMutation,
    MarketingSignupMutationVariables
  >({
    mutation: MarketingSignupDoc,
    ...options,
  });
  return m;
};
export const GetCustomerMarketing = (
  options: Omit<WatchQueryOptions<GetCustomerMarketingQueryVariables>, "query">,
): Readable<
  ApolloQueryResult<GetCustomerMarketingQuery> & {
    query: ObservableQuery<
      GetCustomerMarketingQuery,
      GetCustomerMarketingQueryVariables
    >;
  }
> => {
  const q = client.watchQuery({
    query: GetCustomerMarketingDoc,
    ...options,
  });
  var result = readable<
    ApolloQueryResult<GetCustomerMarketingQuery> & {
      query: ObservableQuery<
        GetCustomerMarketingQuery,
        GetCustomerMarketingQueryVariables
      >;
    }
  >(
    {
      data: {} as any,
      loading: true,
      error: undefined,
      networkStatus: 1,
      query: q,
    },
    set => {
      q.subscribe((v: any) => {
        set({ ...v, query: q });
      });
    },
  );
  return result;
};

export const SetMarketing = (
  options: Omit<
    MutationOptions<any, SetMarketingMutationVariables>,
    "mutation"
  >,
) => {
  const m = client.mutate<SetMarketingMutation, SetMarketingMutationVariables>({
    mutation: SetMarketingDoc,
    ...options,
  });
  return m;
};
export const Banners = (
  options: Omit<WatchQueryOptions<BannersQueryVariables>, "query">,
): Readable<
  ApolloQueryResult<BannersQuery> & {
    query: ObservableQuery<BannersQuery, BannersQueryVariables>;
  }
> => {
  const q = client.watchQuery({
    query: BannersDoc,
    ...options,
  });
  var result = readable<
    ApolloQueryResult<BannersQuery> & {
      query: ObservableQuery<BannersQuery, BannersQueryVariables>;
    }
  >(
    {
      data: {} as any,
      loading: true,
      error: undefined,
      networkStatus: 1,
      query: q,
    },
    set => {
      q.subscribe((v: any) => {
        set({ ...v, query: q });
      });
    },
  );
  return result;
};

export const GetPage = (
  options: Omit<WatchQueryOptions<GetPageQueryVariables>, "query">,
): Readable<
  ApolloQueryResult<GetPageQuery> & {
    query: ObservableQuery<GetPageQuery, GetPageQueryVariables>;
  }
> => {
  const q = client.watchQuery({
    query: GetPageDoc,
    ...options,
  });
  var result = readable<
    ApolloQueryResult<GetPageQuery> & {
      query: ObservableQuery<GetPageQuery, GetPageQueryVariables>;
    }
  >(
    {
      data: {} as any,
      loading: true,
      error: undefined,
      networkStatus: 1,
      query: q,
    },
    set => {
      q.subscribe((v: any) => {
        set({ ...v, query: q });
      });
    },
  );
  return result;
};

export const GetNav = (
  options: Omit<WatchQueryOptions<GetNavQueryVariables>, "query">,
): Readable<
  ApolloQueryResult<GetNavQuery> & {
    query: ObservableQuery<GetNavQuery, GetNavQueryVariables>;
  }
> => {
  const q = client.watchQuery({
    query: GetNavDoc,
    ...options,
  });
  var result = readable<
    ApolloQueryResult<GetNavQuery> & {
      query: ObservableQuery<GetNavQuery, GetNavQueryVariables>;
    }
  >(
    {
      data: {} as any,
      loading: true,
      error: undefined,
      networkStatus: 1,
      query: q,
    },
    set => {
      q.subscribe((v: any) => {
        set({ ...v, query: q });
      });
    },
  );
  return result;
};

export const GetResourceByURL = (
  options: Omit<WatchQueryOptions<GetResourceByUrlQueryVariables>, "query">,
): Readable<
  ApolloQueryResult<GetResourceByUrlQuery> & {
    query: ObservableQuery<
      GetResourceByUrlQuery,
      GetResourceByUrlQueryVariables
    >;
  }
> => {
  const q = client.watchQuery({
    query: GetResourceByUrlDoc,
    ...options,
  });
  var result = readable<
    ApolloQueryResult<GetResourceByUrlQuery> & {
      query: ObservableQuery<
        GetResourceByUrlQuery,
        GetResourceByUrlQueryVariables
      >;
    }
  >(
    {
      data: {} as any,
      loading: true,
      error: undefined,
      networkStatus: 1,
      query: q,
    },
    set => {
      q.subscribe((v: any) => {
        set({ ...v, query: q });
      });
    },
  );
  return result;
};

export const GetNavItemByURL = (
  options: Omit<WatchQueryOptions<GetNavItemByUrlQueryVariables>, "query">,
): Readable<
  ApolloQueryResult<GetNavItemByUrlQuery> & {
    query: ObservableQuery<GetNavItemByUrlQuery, GetNavItemByUrlQueryVariables>;
  }
> => {
  const q = client.watchQuery({
    query: GetNavItemByUrlDoc,
    ...options,
  });
  var result = readable<
    ApolloQueryResult<GetNavItemByUrlQuery> & {
      query: ObservableQuery<
        GetNavItemByUrlQuery,
        GetNavItemByUrlQueryVariables
      >;
    }
  >(
    {
      data: {} as any,
      loading: true,
      error: undefined,
      networkStatus: 1,
      query: q,
    },
    set => {
      q.subscribe((v: any) => {
        set({ ...v, query: q });
      });
    },
  );
  return result;
};

export const GetBreadcrumbsByURL = (
  options: Omit<WatchQueryOptions<GetBreadcrumbsByUrlQueryVariables>, "query">,
): Readable<
  ApolloQueryResult<GetBreadcrumbsByUrlQuery> & {
    query: ObservableQuery<
      GetBreadcrumbsByUrlQuery,
      GetBreadcrumbsByUrlQueryVariables
    >;
  }
> => {
  const q = client.watchQuery({
    query: GetBreadcrumbsByUrlDoc,
    ...options,
  });
  var result = readable<
    ApolloQueryResult<GetBreadcrumbsByUrlQuery> & {
      query: ObservableQuery<
        GetBreadcrumbsByUrlQuery,
        GetBreadcrumbsByUrlQueryVariables
      >;
    }
  >(
    {
      data: {} as any,
      loading: true,
      error: undefined,
      networkStatus: 1,
      query: q,
    },
    set => {
      q.subscribe((v: any) => {
        set({ ...v, query: q });
      });
    },
  );
  return result;
};

export const ValidateToken = (
  options: Omit<WatchQueryOptions<ValidateTokenQueryVariables>, "query">,
): Readable<
  ApolloQueryResult<ValidateTokenQuery> & {
    query: ObservableQuery<ValidateTokenQuery, ValidateTokenQueryVariables>;
  }
> => {
  const q = client.watchQuery({
    query: ValidateTokenDoc,
    ...options,
  });
  var result = readable<
    ApolloQueryResult<ValidateTokenQuery> & {
      query: ObservableQuery<ValidateTokenQuery, ValidateTokenQueryVariables>;
    }
  >(
    {
      data: {} as any,
      loading: true,
      error: undefined,
      networkStatus: 1,
      query: q,
    },
    set => {
      q.subscribe((v: any) => {
        set({ ...v, query: q });
      });
    },
  );
  return result;
};
